import H1, { forwardRef as t } from "react";
var K = { exports: {} }, L = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M1;
function c0() {
  if (M1)
    return L;
  M1 = 1;
  var o = H1, a = Symbol.for("react.element"), D = Symbol.for("react.fragment"), V = Object.prototype.hasOwnProperty, E = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, y = { key: !0, ref: !0, __self: !0, __source: !0 };
  function I(j, g, H) {
    var u, p = {}, A = null, z = null;
    H !== void 0 && (A = "" + H), g.key !== void 0 && (A = "" + g.key), g.ref !== void 0 && (z = g.ref);
    for (u in g)
      V.call(g, u) && !y.hasOwnProperty(u) && (p[u] = g[u]);
    if (j && j.defaultProps)
      for (u in g = j.defaultProps, g)
        p[u] === void 0 && (p[u] = g[u]);
    return { $$typeof: a, type: j, key: A, ref: z, props: p, _owner: E.current };
  }
  return L.Fragment = D, L.jsx = I, L.jsxs = I, L;
}
var b = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var V1;
function h0() {
  return V1 || (V1 = 1, process.env.NODE_ENV !== "production" && function() {
    var o = H1, a = Symbol.for("react.element"), D = Symbol.for("react.portal"), V = Symbol.for("react.fragment"), E = Symbol.for("react.strict_mode"), y = Symbol.for("react.profiler"), I = Symbol.for("react.provider"), j = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), H = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), z = Symbol.for("react.offscreen"), Q = Symbol.iterator, S1 = "@@iterator";
    function C1(l) {
      if (l === null || typeof l != "object")
        return null;
      var n = Q && l[Q] || l[S1];
      return typeof n == "function" ? n : null;
    }
    var S = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function m(l) {
      {
        for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
          r[s - 1] = arguments[s];
        F1("error", l, r);
      }
    }
    function F1(l, n, r) {
      {
        var s = S.ReactDebugCurrentFrame, i = s.getStackAddendum();
        i !== "" && (n += "%s", r = r.concat([i]));
        var v = r.map(function(h) {
          return String(h);
        });
        v.unshift("Warning: " + n), Function.prototype.apply.call(console[l], console, v);
      }
    }
    var I1 = !1, B1 = !1, $1 = !1, L1 = !1, b1 = !1, e1;
    e1 = Symbol.for("react.module.reference");
    function E1(l) {
      return !!(typeof l == "string" || typeof l == "function" || l === V || l === y || b1 || l === E || l === H || l === u || L1 || l === z || I1 || B1 || $1 || typeof l == "object" && l !== null && (l.$$typeof === A || l.$$typeof === p || l.$$typeof === I || l.$$typeof === j || l.$$typeof === g || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      l.$$typeof === e1 || l.getModuleId !== void 0));
    }
    function y1(l, n, r) {
      var s = l.displayName;
      if (s)
        return s;
      var i = n.displayName || n.name || "";
      return i !== "" ? r + "(" + i + ")" : r;
    }
    function a1(l) {
      return l.displayName || "Context";
    }
    function R(l) {
      if (l == null)
        return null;
      if (typeof l.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
        return l.displayName || l.name || null;
      if (typeof l == "string")
        return l;
      switch (l) {
        case V:
          return "Fragment";
        case D:
          return "Portal";
        case y:
          return "Profiler";
        case E:
          return "StrictMode";
        case H:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case j:
            var n = l;
            return a1(n) + ".Consumer";
          case I:
            var r = l;
            return a1(r._context) + ".Provider";
          case g:
            return y1(l, l.render, "ForwardRef");
          case p:
            var s = l.displayName || null;
            return s !== null ? s : R(l.type) || "Memo";
          case A: {
            var i = l, v = i._payload, h = i._init;
            try {
              return R(h(v));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, B = 0, o1, l1, t1, n1, r1, s1, c1;
    function h1() {
    }
    h1.__reactDisabledLog = !0;
    function z1() {
      {
        if (B === 0) {
          o1 = console.log, l1 = console.info, t1 = console.warn, n1 = console.error, r1 = console.group, s1 = console.groupCollapsed, c1 = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: h1,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        B++;
      }
    }
    function _1() {
      {
        if (B--, B === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, l, {
              value: o1
            }),
            info: M({}, l, {
              value: l1
            }),
            warn: M({}, l, {
              value: t1
            }),
            error: M({}, l, {
              value: n1
            }),
            group: M({}, l, {
              value: r1
            }),
            groupCollapsed: M({}, l, {
              value: s1
            }),
            groupEnd: M({}, l, {
              value: c1
            })
          });
        }
        B < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var W = S.ReactCurrentDispatcher, N;
    function _(l, n, r) {
      {
        if (N === void 0)
          try {
            throw Error();
          } catch (i) {
            var s = i.stack.trim().match(/\n( *(at )?)/);
            N = s && s[1] || "";
          }
        return `
` + N + l;
      }
    }
    var U = !1, T;
    {
      var T1 = typeof WeakMap == "function" ? WeakMap : Map;
      T = new T1();
    }
    function i1(l, n) {
      if (!l || U)
        return "";
      {
        var r = T.get(l);
        if (r !== void 0)
          return r;
      }
      var s;
      U = !0;
      var i = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var v;
      v = W.current, W.current = null, z1();
      try {
        if (n) {
          var h = function() {
            throw Error();
          };
          if (Object.defineProperty(h.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(h, []);
            } catch (Z) {
              s = Z;
            }
            Reflect.construct(l, [], h);
          } else {
            try {
              h.call();
            } catch (Z) {
              s = Z;
            }
            l.call(h.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            s = Z;
          }
          l();
        }
      } catch (Z) {
        if (Z && s && typeof Z.stack == "string") {
          for (var c = Z.stack.split(`
`), f = s.stack.split(`
`), d = c.length - 1, w = f.length - 1; d >= 1 && w >= 0 && c[d] !== f[w]; )
            w--;
          for (; d >= 1 && w >= 0; d--, w--)
            if (c[d] !== f[w]) {
              if (d !== 1 || w !== 1)
                do
                  if (d--, w--, w < 0 || c[d] !== f[w]) {
                    var x = `
` + c[d].replace(" at new ", " at ");
                    return l.displayName && x.includes("<anonymous>") && (x = x.replace("<anonymous>", l.displayName)), typeof l == "function" && T.set(l, x), x;
                  }
                while (d >= 1 && w >= 0);
              break;
            }
        }
      } finally {
        U = !1, W.current = v, _1(), Error.prepareStackTrace = i;
      }
      var F = l ? l.displayName || l.name : "", A1 = F ? _(F) : "";
      return typeof l == "function" && T.set(l, A1), A1;
    }
    function P1(l, n, r) {
      return i1(l, !1);
    }
    function k1(l) {
      var n = l.prototype;
      return !!(n && n.isReactComponent);
    }
    function P(l, n, r) {
      if (l == null)
        return "";
      if (typeof l == "function")
        return i1(l, k1(l));
      if (typeof l == "string")
        return _(l);
      switch (l) {
        case H:
          return _("Suspense");
        case u:
          return _("SuspenseList");
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case g:
            return P1(l.render);
          case p:
            return P(l.type, n, r);
          case A: {
            var s = l, i = s._payload, v = s._init;
            try {
              return P(v(i), n, r);
            } catch {
            }
          }
        }
      return "";
    }
    var k = Object.prototype.hasOwnProperty, v1 = {}, d1 = S.ReactDebugCurrentFrame;
    function O(l) {
      if (l) {
        var n = l._owner, r = P(l.type, l._source, n ? n.type : null);
        d1.setExtraStackFrame(r);
      } else
        d1.setExtraStackFrame(null);
    }
    function O1(l, n, r, s, i) {
      {
        var v = Function.call.bind(k);
        for (var h in l)
          if (v(l, h)) {
            var c = void 0;
            try {
              if (typeof l[h] != "function") {
                var f = Error((s || "React class") + ": " + r + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw f.name = "Invariant Violation", f;
              }
              c = l[h](n, h, s, r, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (d) {
              c = d;
            }
            c && !(c instanceof Error) && (O(i), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", s || "React class", r, h, typeof c), O(null)), c instanceof Error && !(c.message in v1) && (v1[c.message] = !0, O(i), m("Failed %s type: %s", r, c.message), O(null));
          }
      }
    }
    var D1 = Array.isArray;
    function Y(l) {
      return D1(l);
    }
    function W1(l) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, r = n && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return r;
      }
    }
    function N1(l) {
      try {
        return w1(l), !1;
      } catch {
        return !0;
      }
    }
    function w1(l) {
      return "" + l;
    }
    function g1(l) {
      if (N1(l))
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", W1(l)), w1(l);
    }
    var $ = S.ReactCurrentOwner, U1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, m1, f1, G;
    G = {};
    function Y1(l) {
      if (k.call(l, "ref")) {
        var n = Object.getOwnPropertyDescriptor(l, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return l.ref !== void 0;
    }
    function G1(l) {
      if (k.call(l, "key")) {
        var n = Object.getOwnPropertyDescriptor(l, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return l.key !== void 0;
    }
    function q1(l, n) {
      if (typeof l.ref == "string" && $.current && n && $.current.stateNode !== n) {
        var r = R($.current.type);
        G[r] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', R($.current.type), l.ref), G[r] = !0);
      }
    }
    function J1(l, n) {
      {
        var r = function() {
          m1 || (m1 = !0, m("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        r.isReactWarning = !0, Object.defineProperty(l, "key", {
          get: r,
          configurable: !0
        });
      }
    }
    function X1(l, n) {
      {
        var r = function() {
          f1 || (f1 = !0, m("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        r.isReactWarning = !0, Object.defineProperty(l, "ref", {
          get: r,
          configurable: !0
        });
      }
    }
    var K1 = function(l, n, r, s, i, v, h) {
      var c = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: a,
        // Built-in properties that belong on the element
        type: l,
        key: n,
        ref: r,
        props: h,
        // Record the component responsible for creating this element.
        _owner: v
      };
      return c._store = {}, Object.defineProperty(c._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(c, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.defineProperty(c, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.freeze && (Object.freeze(c.props), Object.freeze(c)), c;
    };
    function Q1(l, n, r, s, i) {
      {
        var v, h = {}, c = null, f = null;
        r !== void 0 && (g1(r), c = "" + r), G1(n) && (g1(n.key), c = "" + n.key), Y1(n) && (f = n.ref, q1(n, i));
        for (v in n)
          k.call(n, v) && !U1.hasOwnProperty(v) && (h[v] = n[v]);
        if (l && l.defaultProps) {
          var d = l.defaultProps;
          for (v in d)
            h[v] === void 0 && (h[v] = d[v]);
        }
        if (c || f) {
          var w = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
          c && J1(h, w), f && X1(h, w);
        }
        return K1(l, c, f, i, s, $.current, h);
      }
    }
    var q = S.ReactCurrentOwner, u1 = S.ReactDebugCurrentFrame;
    function C(l) {
      if (l) {
        var n = l._owner, r = P(l.type, l._source, n ? n.type : null);
        u1.setExtraStackFrame(r);
      } else
        u1.setExtraStackFrame(null);
    }
    var J;
    J = !1;
    function X(l) {
      return typeof l == "object" && l !== null && l.$$typeof === a;
    }
    function x1() {
      {
        if (q.current) {
          var l = R(q.current.type);
          if (l)
            return `

Check the render method of \`` + l + "`.";
        }
        return "";
      }
    }
    function e0(l) {
      {
        if (l !== void 0) {
          var n = l.fileName.replace(/^.*[\\\/]/, ""), r = l.lineNumber;
          return `

Check your code at ` + n + ":" + r + ".";
        }
        return "";
      }
    }
    var p1 = {};
    function a0(l) {
      {
        var n = x1();
        if (!n) {
          var r = typeof l == "string" ? l : l.displayName || l.name;
          r && (n = `

Check the top-level render call using <` + r + ">.");
        }
        return n;
      }
    }
    function R1(l, n) {
      {
        if (!l._store || l._store.validated || l.key != null)
          return;
        l._store.validated = !0;
        var r = a0(n);
        if (p1[r])
          return;
        p1[r] = !0;
        var s = "";
        l && l._owner && l._owner !== q.current && (s = " It was passed a child from " + R(l._owner.type) + "."), C(l), m('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', r, s), C(null);
      }
    }
    function Z1(l, n) {
      {
        if (typeof l != "object")
          return;
        if (Y(l))
          for (var r = 0; r < l.length; r++) {
            var s = l[r];
            X(s) && R1(s, n);
          }
        else if (X(l))
          l._store && (l._store.validated = !0);
        else if (l) {
          var i = C1(l);
          if (typeof i == "function" && i !== l.entries)
            for (var v = i.call(l), h; !(h = v.next()).done; )
              X(h.value) && R1(h.value, n);
        }
      }
    }
    function o0(l) {
      {
        var n = l.type;
        if (n == null || typeof n == "string")
          return;
        var r;
        if (typeof n == "function")
          r = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === g || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === p))
          r = n.propTypes;
        else
          return;
        if (r) {
          var s = R(n);
          O1(r, l.props, "prop", s, l);
        } else if (n.PropTypes !== void 0 && !J) {
          J = !0;
          var i = R(n);
          m("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && m("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function l0(l) {
      {
        for (var n = Object.keys(l.props), r = 0; r < n.length; r++) {
          var s = n[r];
          if (s !== "children" && s !== "key") {
            C(l), m("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", s), C(null);
            break;
          }
        }
        l.ref !== null && (C(l), m("Invalid attribute `ref` supplied to `React.Fragment`."), C(null));
      }
    }
    function j1(l, n, r, s, i, v) {
      {
        var h = E1(l);
        if (!h) {
          var c = "";
          (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (c += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var f = e0(i);
          f ? c += f : c += x1();
          var d;
          l === null ? d = "null" : Y(l) ? d = "array" : l !== void 0 && l.$$typeof === a ? (d = "<" + (R(l.type) || "Unknown") + " />", c = " Did you accidentally export a JSX literal instead of a component?") : d = typeof l, m("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", d, c);
        }
        var w = Q1(l, n, r, i, v);
        if (w == null)
          return w;
        if (h) {
          var x = n.children;
          if (x !== void 0)
            if (s)
              if (Y(x)) {
                for (var F = 0; F < x.length; F++)
                  Z1(x[F], l);
                Object.freeze && Object.freeze(x);
              } else
                m("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Z1(x, l);
        }
        return l === V ? l0(w) : o0(w), w;
      }
    }
    function t0(l, n, r) {
      return j1(l, n, r, !0);
    }
    function n0(l, n, r) {
      return j1(l, n, r, !1);
    }
    var r0 = n0, s0 = t0;
    b.Fragment = V, b.jsx = r0, b.jsxs = s0;
  }()), b;
}
process.env.NODE_ENV === "production" ? K.exports = c0() : K.exports = h0();
var e = K.exports;
const i0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M18.509 1.2c.347 0 .68.135.929.377l8.357 8.111c.259.251.405.596.405.957v17.196c0 .785-.321 1.538-.893 2.093s-1.348.867-2.157.867H6.85c-.809 0-1.585-.312-2.157-.867S3.8 28.626 3.8 27.841V4.161c0-.785.321-1.538.893-2.093s1.348-.867 2.157-.867h11.659zM17.333 16a1.333 1.333 0 0 0-2.666 0v2.667H12a1.333 1.333 0 0 0 0 2.666h2.667V24a1.333 1.333 0 0 0 2.666 0v-2.667H20a1.333 1.333 0 0 0 0-2.666h-2.667V16zM18.2 4.166V10.4a.8.8 0 0 0 .8.8h6.234a.4.4 0 0 0 .283-.683l-6.634-6.634a.4.4 0 0 0-.683.283z" }) }), K2 = t(i0), v0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.5 4A1.5 1.5 0 0 1 5 2.5h4.172c.025 0 .05 0 .076.002-.907 1.933 1.145 4.194 3.248 3.21.002.039.004.078.004.116V8a.5.5 0 0 0 1 0V5.828a2.5 2.5 0 0 0-.732-1.767l-1.829-1.829A2.5 2.5 0 0 0 9.172 1.5H5A2.5 2.5 0 0 0 2.5 4v8A2.5 2.5 0 0 0 5 14.5h4.5a.5.5 0 0 0 0-1H5A1.5 1.5 0 0 1 3.5 12V4Zm8.59.798-.03-.03-1.828-1.829a1.514 1.514 0 0 0-.056-.053c-.563 1.148.663 2.507 1.914 1.912ZM5 8.5a.5.5 0 0 1 .5-.5h2V6a.5.5 0 0 1 1 0v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0V9h-2a.5.5 0 0 1-.5-.5Zm8.5 1.5a.5.5 0 0 0-.686-.464l-1.5.6a.5.5 0 1 0 .372.928l.814-.325V14h-1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-1v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), Q2 = t(v0), d0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.071 4.571a.571.571 0 1 0-1.142 0v2.856H5.07a.571.571 0 0 0 0 1.143H7.93v2.859a.571.571 0 0 0 1.142 0V8.57h2.858a.571.571 0 1 0 0-1.143H9.07V4.571Z",
        clipRule: "evenodd"
      }
    )
  }
), e4 = t(d0), w0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M2 4.5A2.5 2.5 0 0 1 4.5 2h4a2.5 2.5 0 0 1 2.45 2H9.915A1.5 1.5 0 0 0 8.5 3h-4A1.5 1.5 0 0 0 3 4.5v4a1.5 1.5 0 0 0 1 1.415v1.035A2.5 2.5 0 0 1 2 8.5v-4Zm5.5.5A2.5 2.5 0 0 0 5 7.5v4A2.5 2.5 0 0 0 7.5 14h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 11.5 5h-4ZM6 7.5A1.5 1.5 0 0 1 7.5 6h4A1.5 1.5 0 0 1 13 7.5v4a1.5 1.5 0 0 1-1.5 1.5h-4A1.5 1.5 0 0 1 6 11.5v-4Zm1 2a.5.5 0 0 1 .5-.5H9V7.5a.5.5 0 0 1 1 0V9h1.5a.5.5 0 0 1 0 1H10v1.5a.5.5 0 0 1-1 0V10H7.5a.5.5 0 0 1-.5-.5Z" }) }), a4 = t(w0), g0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.397 12.8c-.331 0-.613-.118-.847-.353a1.165 1.165 0 0 1-.35-.85c0-.331.118-.614.354-.847.235-.233.519-.35.85-.35.33 0 .613.118.846.354.234.235.35.519.35.85 0 .33-.118.613-.353.846-.236.234-.52.35-.85.35Zm3.6 0c-.331 0-.613-.118-.847-.353a1.165 1.165 0 0 1-.35-.85c0-.331.118-.614.354-.847.235-.233.519-.35.85-.35.33 0 .613.118.846.354.234.235.35.519.35.85 0 .33-.118.613-.353.846-.236.234-.52.35-.85.35Zm3.6 0c-.331 0-.614-.118-.847-.353a1.165 1.165 0 0 1-.35-.85c0-.331.118-.614.354-.847.235-.233.519-.35.85-.35.33 0 .613.118.846.354.234.235.35.519.35.85 0 .33-.118.613-.353.846-.236.234-.52.35-.85.35Zm-7.2-3.6c-.331 0-.613-.118-.847-.353a1.165 1.165 0 0 1-.35-.85c0-.331.118-.613.354-.847.235-.233.519-.35.85-.35.33 0 .613.118.846.354.234.235.35.519.35.85 0 .33-.118.613-.353.846-.236.234-.52.35-.85.35Zm3.6 0c-.331 0-.613-.118-.847-.353a1.165 1.165 0 0 1-.35-.85c0-.331.118-.613.354-.847.235-.233.519-.35.85-.35.33 0 .613.118.846.354.234.235.35.519.35.85 0 .33-.118.613-.353.846-.236.234-.52.35-.85.35Zm3.6 0c-.331 0-.614-.118-.847-.353a1.165 1.165 0 0 1-.35-.85c0-.331.118-.613.354-.847.235-.233.519-.35.85-.35.33 0 .613.118.846.354.234.235.35.519.35.85 0 .33-.118.613-.353.846-.236.234-.52.35-.85.35Zm-7.2-3.6c-.331 0-.613-.118-.847-.353a1.165 1.165 0 0 1-.35-.85c0-.331.118-.613.354-.847.235-.233.519-.35.85-.35.33 0 .613.118.846.354.234.235.35.519.35.85 0 .33-.118.613-.353.846-.236.234-.52.35-.85.35Zm3.6 0c-.331 0-.613-.118-.847-.353a1.165 1.165 0 0 1-.35-.85c0-.331.118-.613.354-.847.235-.233.519-.35.85-.35.33 0 .613.118.846.354.234.235.35.519.35.85 0 .33-.118.613-.353.846-.236.234-.52.35-.85.35Zm3.6 0c-.331 0-.614-.118-.847-.353a1.165 1.165 0 0 1-.35-.85c0-.331.118-.613.354-.847.235-.233.519-.35.85-.35.33 0 .613.118.846.354.234.235.35.519.35.85 0 .33-.118.613-.353.846-.236.234-.52.35-.85.35Z"
      }
    )
  }
), o4 = t(g0), m0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "#161B27",
        fillRule: "evenodd",
        d: "M9.727 16.283a.713.713 0 0 0 .773-.15m.006-.005 5.713-5.714a.714.714 0 1 0-1.01-1.01l-4.495 4.495V4.195a.714.714 0 0 0-1.428 0v9.704L4.79 9.404a.714.714 0 0 0-1.01 1.01l5.714 5.714a.71.71 0 0 0 .232.155",
        clipRule: "evenodd"
      }
    )
  }
), l4 = t(m0), f0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m12.5 15.833-1.188-1.166 3.834-3.834H1.666V9.167h13.48l-3.813-3.834L12.5 4.167 18.333 10 12.5 15.833Z"
      }
    )
  }
), t4 = t(f0), u0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M12.707 18.293 7.414 13H19a1 1 0 0 0 0-2H7.414l5.293-5.293a.999.999 0 1 0-1.414-1.414l-7 7a.998.998 0 0 0 0 1.414l7 7a.999.999 0 1 0 1.414-1.414z" }) }), n4 = t(u0), x0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "M4.5 16.667 3.333 15.5 13 5.833H7.5V4.167h8.333V12.5h-1.666V7L4.5 16.667Z" })
  }
), r4 = t(x0), p0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "M15.5 16.667 5.833 7v5.5H4.167V4.167H12.5v1.666H7l9.667 9.667-1.167 1.167Z" })
  }
), s4 = t(p0), R0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.167 18.333V4.854L5.333 8.667 4.167 7.5 10 1.667 15.833 7.5l-1.166 1.187-3.834-3.833v13.48H9.167Z"
      }
    )
  }
), c4 = t(R0), Z0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M16 5.333 14.113 7.22l7.447 7.447H5.333v2.667H21.56l-7.447 7.447L16 26.668l10.667-10.667z" }) }), h4 = t(Z0), j0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "M7.5 15.833v-1.666H13L3.333 4.5 4.5 3.333 14.167 13V7.5h1.666v8.333H7.5Z" })
  }
), i4 = t(j0), A0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "M4.167 15.833V7.5h1.666V13L15.5 3.333 16.667 4.5 7 14.167h5.5v1.666H4.167Z" })
  }
), v4 = t(A0), M0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10 18.333 4.167 12.5l1.166-1.167 3.834 3.813V1.666h1.666v13.48l3.834-3.834 1.166 1.188L10 18.333Z"
      }
    )
  }
), d4 = t(M0), V0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 20 20", ref: a, ...o, children: /* @__PURE__ */ e.jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M16.22 9.404a.714.714 0 1 1-1.01 1.01L10.713 5.92v9.704a.714.714 0 0 1-1.428 0V5.92L4.79 10.414a.714.714 0 1 1-1.01-1.01L9.495 3.69a.712.712 0 0 1 1.009-.002m5.715 5.716L10.505 3.69l5.714 5.714Z",
    clipRule: "evenodd"
  }
) }), w4 = t(V0), H0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 15.833 1.667 10 7.5 4.167l1.167 1.166-3.813 3.834h13.48v1.666H4.853l3.833 3.834L7.5 15.833Z"
      }
    )
  }
), g4 = t(H0), S0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsxs("g", { fill: "#1C1B1F", children: [
      /* @__PURE__ */ e.jsx("path", { d: "M8.545 3.333H3.75c-.344 0-.638.122-.883.365a1.196 1.196 0 0 0-.367.881v1.252c0 .345.122.64.365.884a1.2 1.2 0 0 0 .885.368v6.667c0 .807.284 1.495.85 2.063a2.804 2.804 0 0 0 2.063.854 2.81 2.81 0 0 0 1.632-.49 2.249 2.249 0 0 1-.128-.76v-.925a1.674 1.674 0 0 1-.32.438 1.607 1.607 0 0 1-1.18.487c-.463 0-.857-.162-1.18-.486A1.607 1.607 0 0 1 5 13.75V7.083h3.167v-1.25H3.75v-1.25h4.417c0-.46.13-.884.378-1.25Z" }),
      /* @__PURE__ */ e.jsx("path", { d: "M8.167 8.333h-1.5v1.25h1.5v-1.25ZM8.167 13.75V12.5h-1.5v1.25h1.5ZM8.167 11.667v-1.25h-1.5v1.25h1.5ZM17.5 15.417c0 .343-.122.638-.367.882a1.204 1.204 0 0 1-.883.368h-5.833c-.344 0-.638-.123-.883-.368a1.204 1.204 0 0 1-.367-.882V4.583c0-.343.122-.638.367-.882.245-.245.539-.368.883-.368h5.833c.344 0 .638.123.883.368.245.244.367.539.367.882v10.834Zm-1.25 0V4.583h-5.833v2.084h2.916v1.25h-2.916v1.458h2.916v1.25h-2.916v1.458h2.916v1.25h-2.916v2.084h5.833Z" })
    ] })
  }
), m4 = t(S0), C0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.61 4.452a3.572 3.572 0 0 1 2.112.378l.564.296v8.738a5 5 0 0 0-3.572-1.158v-8.14l.895-.114Zm2.775-.887.615.322-.032.715.032-.715.615-.322a5 5 0 0 1 2.958-.53l1.518.195c.357.046.623.35.623.709v.26c.176.042.352.09.526.141l1.108.333c.302.09.51.369.51.684v10.714a.714.714 0 0 1-.98.663l-.389-.155a7.857 7.857 0 0 0-5.836 0l-.386.155a.714.714 0 0 1-.532 0l-.005-.002-.383-.153a7.857 7.857 0 0 0-5.836 0l-.389.155a.714.714 0 0 1-.98-.663V5.357c0-.315.208-.594.51-.684L3.76 4.34c.174-.052.35-.099.526-.14v-.261c0-.36.267-.663.623-.709l1.518-.195a5 5 0 0 1 2.958.53Zm-5.1 2.11a7.83 7.83 0 0 0-.114.034l-.6.18v9.15a9.286 9.286 0 0 1 4.5-.304 3.571 3.571 0 0 0-2.456-.584l-.524.068a.714.714 0 0 1-.805-.709V5.675Zm5.212 9.436.002.001.466-10.437-.468 10.436Zm2.431-.376a9.287 9.287 0 0 1 4.5.304V5.89l-.599-.18a7.555 7.555 0 0 0-.115-.034v7.835a.714.714 0 0 1-.805.709l-.524-.068a3.571 3.571 0 0 0-2.457.584Zm-1.214-.871V5.126l.564-.296a3.572 3.572 0 0 1 2.113-.378l.895.115v8.14a5 5 0 0 0-3.572 1.157Z",
        clipRule: "evenodd"
      }
    )
  }
), f4 = t(C0), F0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx("circle", { cx: 10, cy: 10, r: 2, fill: "currentColor" })
  }
), u4 = t(F0), I0 = (o, a) => /* @__PURE__ */ e.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: [
  /* @__PURE__ */ e.jsx("path", { d: "M9.333 14.666H12v2.667H9.333v-2.667zm0 5.334H12v2.667H9.333V20zm5.333-5.334h2.667v2.667h-2.667v-2.667zm0 5.334h2.667v2.667h-2.667V20zM20 14.666h2.667v2.667H20v-2.667zM20 20h2.667v2.667H20V20z" }),
  /* @__PURE__ */ e.jsx("path", { d: "M6.667 29.333h18.667a2.67 2.67 0 0 0 2.667-2.667V7.999a2.67 2.67 0 0 0-2.667-2.667h-2.667V2.665H20v2.667h-8V2.665H9.333v2.667H6.666a2.67 2.67 0 0 0-2.667 2.667v18.667a2.67 2.67 0 0 0 2.667 2.667zm18.666-18.667.001 16H6.666v-16h18.667z" })
] }), x4 = t(I0), B0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M17.016 15.609 13.407 12l3.609-3.609-1.406-1.406-3.609 3.609-3.609-3.609-1.406 1.406L10.595 12l-3.609 3.609 1.406 1.406 3.609-3.609 3.609 3.609zM12 2.016q4.125 0 7.055 2.93t2.93 7.055-2.93 7.055T12 21.986t-7.055-2.93-2.93-7.055 2.93-7.055T12 2.016z" }) }), p4 = t(B0), $0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", ref: a, ...o, children: /* @__PURE__ */ e.jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M5.04 3.62c-.83 0-1.54.59-1.69 1.41l-.4 2.3h-.09c-.95 0-1.72.77-1.72 1.72v1.42c0 .95.77 1.72 1.72 1.72h.02c.14.97.97 1.71 1.98 1.71.9 0 1.67-.6 1.91-1.43h1.88a2.01 2.01 0 0 0 1.92 1.43c1.01 0 1.84-.74 1.98-1.71h.59c.95 0 1.72-.77 1.72-1.72V9.05c0-.95-.77-1.72-1.72-1.72h-1.35l-1.27-2.72c-.28-.61-.89-.99-1.56-.99H5.04zm6.38 4.85h1.72c.32 0 .57.26.57.58v1.42c0 .32-.25.58-.57.58h-.76a2 2 0 0 0-1.81-1.15c-.9 0-1.67.61-1.92 1.43H6.77A2.001 2.001 0 0 0 4.86 9.9a2 2 0 0 0-1.81 1.15h-.19c-.32 0-.57-.26-.57-.58V9.05c0-.32.25-.58.57-.58H11.42zm-.89-1.14L9.48 5.09a.564.564 0 0 0-.52-.33H7.52v2.57h3.01zm-4.15 0V4.76H5.04c-.28 0-.51.2-.56.47l-.37 2.1h2.27zm-1.52 3.72c-.48 0-.86.38-.86.85 0 .48.38.86.86.86.47 0 .85-.38.85-.86a.85.85 0 0 0-.85-.85zm5.71 0c-.47 0-.86.38-.86.85a.86.86 0 1 0 1.72 0c0-.47-.39-.85-.86-.85z",
    clipRule: "evenodd"
  }
) }), R4 = t($0), L0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.207 6C4.317 6 3.87 7.077 4.5 7.707l2.44 2.44a1.5 1.5 0 0 0 2.12 0l2.44-2.44c.63-.63.184-1.707-.707-1.707H5.207Z",
        clipRule: "evenodd"
      }
    )
  }
), Z4 = t(L0), b0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 10.793c0 .89 1.077 1.337 1.707.707l2.44-2.44a1.5 1.5 0 0 0 0-2.12L7.706 4.5C7.077 3.87 6 4.316 6 5.207v5.586Z",
        clipRule: "evenodd"
      }
    )
  }
), j4 = t(b0), E0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", ref: a, ...o, children: /* @__PURE__ */ e.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M2 14v-1.333l1.333-1.334V14H2Zm2.667 0v-4L6 8.667V14H4.667Zm2.666 0V8.667l1.334 1.35V14H7.333ZM10 14v-3.983l1.333-1.334V14H10Zm2.667 0V7.333L14 6v8h-1.333ZM2 10.55V8.667L6.667 4l2.666 2.667L14 2v1.883L9.333 8.55 6.667 5.883 2 10.55Z"
  }
) }), A4 = t(E0), y0 = (o, a) => /* @__PURE__ */ e.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: [
  /* @__PURE__ */ e.jsx("path", { d: "M4 4v22.667a1.335 1.335 0 0 0 1.334 1.334h22.667v-2.667H6.668V4.001H4.001z" }),
  /* @__PURE__ */ e.jsx("path", { d: "M20.39 19.609a1.332 1.332 0 0 0 1.885 0l6.667-6.667-1.885-1.885-5.724 5.724-3.057-3.057a1.338 1.338 0 0 0-.942-.391 1.33 1.33 0 0 0-.942.391l-6.667 6.667 1.885 1.885 5.724-5.724 3.057 3.057z" })
] }), M4 = t(y0), z0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M19.293 5.293 9 15.586l-4.293-4.293a.999.999 0 1 0-1.414 1.414l5 5a.999.999 0 0 0 1.414 0l11-11a.999.999 0 1 0-1.414-1.414z" }) }), V4 = t(z0), _0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7ZM3 4.5A1.5 1.5 0 0 1 4.5 3h7A1.5 1.5 0 0 1 13 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5v-7Zm8.354 1.854a.5.5 0 0 0-.708-.708L7 9.293 5.354 7.646a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), H4 = t(_0), T0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7Zm9.354 1.854a.5.5 0 0 0-.708-.708L7 9.293 5.354 7.646a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l4-4Z",
        clipRule: "evenodd"
      }
    )
  }
), S4 = t(T0), P0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx("rect", { width: 11, height: 11, x: 2.5, y: 2.5, fill: "#DBDEED", stroke: "currentColor", rx: 2 })
  }
), C4 = t(P0), k0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7ZM3 4.5A1.5 1.5 0 0 1 4.5 3h7A1.5 1.5 0 0 1 13 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5v-7Zm2.5 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
        clipRule: "evenodd"
      }
    )
  }
), F4 = t(k0), O0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7ZM4.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-7Z",
        clipRule: "evenodd"
      }
    )
  }
), I4 = t(O0), D0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "m5.293 9.707 6 6a.999.999 0 0 0 1.414 0l6-6a.999.999 0 1 0-1.414-1.414L12 13.586 6.707 8.293a.999.999 0 1 0-1.414 1.414z" }) }), B4 = t(D0), W0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M8.824 12.605a.853.853 0 0 1 0-1.21l5.14-5.145a.858.858 0 0 1 1.21 1.215L10.643 12l4.535 4.535a.858.858 0 0 1-1.211 1.215Zm0 0"
  }
) }), $4 = t(W0), N0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "m9.707 18.707 6-6a.999.999 0 0 0 0-1.414l-6-6a.999.999 0 1 0-1.414 1.414L13.586 12l-5.293 5.293a.999.999 0 1 0 1.414 1.414z" }) }), L4 = t(N0), U0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "m18.707 14.293-6-6a.999.999 0 0 0-1.414 0l-6 6a.999.999 0 1 0 1.414 1.414L12 10.414l5.293 5.293a.999.999 0 1 0 1.414-1.414z" }) }), b4 = t(U0), Y0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 14 14", ref: a, ...o, children: /* @__PURE__ */ e.jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M8.627.929a6.286 6.286 0 0 0-4.77.627.571.571 0 1 0 .571.99 5.143 5.143 0 0 1 5.143 8.908.571.571 0 0 0 .572.99A6.286 6.286 0 0 0 8.627.929ZM3.363 2.555a.571.571 0 0 1 0 .809l-.001.001a.571.571 0 1 1-.809-.808l.002-.002a.571.571 0 0 1 .808 0ZM2.13 3.958c.283.14.399.483.26.766l-.003.003a.571.571 0 0 1-1.025-.505l.003-.004c.14-.283.482-.4.765-.26Zm-.72 1.727a.571.571 0 0 1 .492.642v.004a.571.571 0 0 1-1.133-.149v-.005a.571.571 0 0 1 .642-.492Zm-.125 1.867c.31-.061.61.14.671.45l.001.003a.571.571 0 1 1-1.12.224l-.002-.005a.571.571 0 0 1 .45-.672Zm.48 1.808a.571.571 0 0 1 .781.21l.001.002.001.001a.571.571 0 0 1-.99.572v-.002l-.002-.002a.571.571 0 0 1 .21-.78Zm1.037 1.558a.571.571 0 0 1 .806-.053l.004.003a.571.571 0 1 1-.754.86l-.004-.004a.571.571 0 0 1-.052-.806Zm1.482 1.142a.571.571 0 0 1 .747-.31l.002.002h.002a.571.571 0 1 1-.437 1.056h-.003l-.002-.002a.571.571 0 0 1-.309-.746Zm4.748.312a.571.571 0 0 1-.404.7h-.003a.571.571 0 0 1-.295-1.104h.002c.305-.082.618.099.7.404Zm-2.977.292a.571.571 0 0 1 .607-.532h.005a.571.571 0 1 1-.075 1.14h-.005a.571.571 0 0 1-.532-.608ZM7 3c.316 0 .571.256.571.572v3.075l1.97.985a.571.571 0 0 1-.51 1.022L6.743 7.511a.571.571 0 0 1-.316-.51V3.57c0-.315.256-.57.572-.57Z",
    clipRule: "evenodd"
  }
) }), E4 = t(Y0), G0 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M23 12c0-3.037-1.232-5.789-3.222-7.778S15.037 1 12 1 6.211 2.232 4.222 4.222 1 8.963 1 12s1.232 5.789 3.222 7.778S8.963 23 12 23s5.789-1.232 7.778-3.222S23 15.037 23 12zm-2 0c0 2.486-1.006 4.734-2.636 6.364S14.486 21 12 21s-4.734-1.006-6.364-2.636S3 14.486 3 12s1.006-4.734 2.636-6.364S9.514 3 12 3s4.734 1.006 6.364 2.636S21 9.514 21 12zM11 6v6a1 1 0 0 0 .553.894l4 2a1 1 0 0 0 .895-1.789L13 11.382V6a1 1 0 0 0-2 0z" }) }), y4 = t(G0), q0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.5 2A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2h7Zm-1 11h1a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-1v10Zm-6-10A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h5V3h-5Zm.646 2.646a.5.5 0 0 1 .63-.064l.078.064 2 2 .064.079a.5.5 0 0 1-.064.629l-2 2a.5.5 0 1 1-.708-.708L6.793 8 5.146 6.354l-.064-.079a.5.5 0 0 1 .064-.629Z"
      }
    )
  }
), z4 = t(q0), J0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.5 3a.5.5 0 0 1 .5.5v2.793l1.146-1.147a.5.5 0 1 1 .708.708l-2 2A.498.498 0 0 1 3.5 8c.128 0 .256.049.354.146l2 2a.5.5 0 0 1-.708.708L4 9.707V12.5a.5.5 0 0 1-1 0V9.707l-1.146 1.147a.5.5 0 0 1-.708-.708l2-2A.498.498 0 0 1 3.5 8a.498.498 0 0 1-.354-.146l-2-2a.5.5 0 1 1 .708-.708L3 6.293V3.5a.5.5 0 0 1 .5-.5Zm4 1.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM7 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 7 8Zm.5 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z",
        clipRule: "evenodd"
      }
    )
  }
), _4 = t(J0), X0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "#000",
        fillRule: "evenodd",
        d: "M2.646 5.854a.5.5 0 1 1 .708-.708l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L4.793 8 2.646 5.854Zm10.708 0a.5.5 0 0 0-.708-.708l-2.5 2.5a.5.5 0 0 0 0 .708l2.5 2.5a.5.5 0 0 0 .708-.708L11.207 8l2.147-2.146Z",
        clipRule: "evenodd"
      }
    )
  }
), T4 = t(X0), K0 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 4h6.4v1.2H8V4Zm0 3.4h6.4v1.2H8V7.4Zm0 3.4h6.4V12H8v-1.2ZM4 8l-2.4 2.4.85.85.95-.95v2.5h1.2v-2.5l.95.95.85-.85L4 8ZM4 8 1.6 5.6l.85-.85.95.95V3.2h1.2v2.5l.95-.95.85.85L4 8Z"
      }
    )
  }
), P4 = t(K0), Q0 = (o, a) => /* @__PURE__ */ e.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: [
  /* @__PURE__ */ e.jsx("path", { d: "M6.667 5.333a1.335 1.335 0 0 0-1.334 1.334v18.114l3.057-3.057c.25-.25.589-.391.943-.391h16a1.334 1.334 0 0 0 1.334-1.334V6.666a1.334 1.334 0 0 0-1.334-1.334H6.666zM3.838 3.838a4.001 4.001 0 0 1 2.828-1.172h18.667a4.003 4.003 0 0 1 4 4v13.333a4.001 4.001 0 0 1-4 4H9.885l-4.943 4.943a1.334 1.334 0 0 1-2.276-.943V6.666c0-1.061.421-2.078 1.172-2.828z" }),
  /* @__PURE__ */ e.jsx("path", { d: "M12 13.4a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0zM18 13.4a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0zM24 13.4a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0z" })
] }), k4 = t(Q0), e5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.429 1.714c-.947 0-1.715.768-1.715 1.715v7.428c0 .947.768 1.714 1.715 1.714h2.179c.187 0 .362.091.468.245l.519.741a1.714 1.714 0 0 0 2.81 0l.518-.741a.571.571 0 0 1 .469-.245h2.18c.946 0 1.714-.767 1.714-1.714V3.43c0-.947-.768-1.715-1.715-1.715H3.43ZM2.857 3.43c0-.316.256-.572.572-.572h9.142c.316 0 .572.256.572.572v7.428a.571.571 0 0 1-.572.572h-2.18c-.56 0-1.084.273-1.404.732l-.519.742a.571.571 0 0 1-.937 0l-.518-.742a1.714 1.714 0 0 0-1.405-.732h-2.18a.571.571 0 0 1-.57-.572V3.43Zm2.286.857a.571.571 0 0 0 0 1.143h5.714a.571.571 0 0 0 0-1.143H5.143ZM4.57 7.143c0-.316.256-.572.572-.572h5.714a.571.571 0 1 1 0 1.143H5.143a.571.571 0 0 1-.572-.571Zm.572 1.714a.571.571 0 0 0 0 1.143h4a.571.571 0 0 0 0-1.143h-4Z",
        clipRule: "evenodd"
      }
    )
  }
), O4 = t(e5), a5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 3.5A1.5 1.5 0 0 1 3.5 2h4A1.5 1.5 0 0 1 9 3.5a.5.5 0 0 0 1 0A2.5 2.5 0 0 0 7.5 1h-4A2.5 2.5 0 0 0 1 3.5v4c0 .79.367 1.494.937 1.951a.5.5 0 0 0 .626-.78A1.496 1.496 0 0 1 2 7.5v-4ZM4 4a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H4Zm5 4a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H9ZM3.5 6.5A.5.5 0 0 1 4 6h1a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5ZM10 10a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM6 7.5A2.5 2.5 0 0 1 8.5 5h4A2.5 2.5 0 0 1 15 7.5v4a2.5 2.5 0 0 1-1.875 2.421.5.5 0 0 1-.25-.968A1.5 1.5 0 0 0 14 11.5v-4A1.5 1.5 0 0 0 12.5 6h-4A1.5 1.5 0 0 0 7 7.5V10a.5.5 0 0 1-1 0V7.5Zm2.146 3.646-1.5 1.5a.5.5 0 0 0 0 .708l1.5 1.5a.5.5 0 0 0 .708-.708l-.647-.646H11a.5.5 0 0 0 0-1H8.207l.647-.646a.5.5 0 0 0-.708-.708Zm-2.292 0-1.5-1.5a.5.5 0 1 0-.708.708l.647.646H1.5a.5.5 0 0 0 0 1h2.793l-.647.646a.5.5 0 0 0 .708.708l1.5-1.5a.5.5 0 0 0 0-.708Z",
        clipRule: "evenodd"
      }
    )
  }
), D4 = t(a5), o5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.429 4.286c0-1.184.959-2.143 2.142-2.143h7.143c1.184 0 2.143.96 2.143 2.143v7.143c0 1.183-.96 2.142-2.143 2.142H15v-1.428h.714c.395 0 .715-.32.715-.715V4.286a.714.714 0 0 0-.715-.715H8.571a.714.714 0 0 0-.714.715V5H6.43v-.714ZM4.286 6.429c-1.184 0-2.143.959-2.143 2.142v7.143c0 1.184.96 2.143 2.143 2.143h7.143c1.183 0 2.143-.96 2.143-2.143V8.571c0-1.183-.96-2.142-2.143-2.142H4.286ZM3.57 8.57c0-.394.32-.714.715-.714h7.143c.394 0 .714.32.714.714v7.143c0 .395-.32.714-.714.714H4.286a.714.714 0 0 1-.715-.714V8.571Z",
        clipRule: "evenodd"
      }
    )
  }
), W4 = t(o5), l5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M1.6 13.6V2.8H8v2.4h6.4v8.4H1.6Zm1.2-1.2h4v-1.2h-4v1.2Zm0-2.4h4V8.8h-4V10Zm0-2.4h4V6.4h-4v1.2Zm0-2.4h4V4h-4v1.2ZM8 12.4h5.2v-6H8v6Zm1.2-3.6V7.6H12v1.2H9.2Zm0 2.4V10H12v1.2H9.2Z"
      }
    )
  }
), N4 = t(l5), t5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.061 2.67c-.744.413-1.06.904-1.06 1.33 0 .426.316.917 1.06 1.33.727.405 1.765.67 2.94.67 1.174 0 2.212-.265 2.939-.67C11.684 4.918 12 4.427 12 4c0-.426-.316-.917-1.06-1.33C10.213 2.264 9.175 2 8 2c-1.174 0-2.212.265-2.939.67ZM3.001 4c0-.954.69-1.713 1.575-2.205C5.477 1.295 6.689 1 8 1c1.312 0 2.524.294 3.425.795C12.31 2.287 13 3.045 13 4v8c0 .954-.69 1.713-1.575 2.205-.901.5-2.113.795-3.425.795-1.31 0-2.523-.294-3.424-.795C3.69 13.713 3 12.955 3 12V4Zm1 4c0 .426.316.917 1.06 1.33.727.405 1.765.67 2.94.67 1.174 0 2.212-.265 2.939-.67C11.684 8.918 12 8.427 12 8V5.823a4.213 4.213 0 0 1-.575.382C10.524 6.705 9.312 7 8 7c-1.31 0-2.523-.294-3.424-.795A4.214 4.214 0 0 1 4 5.823V8Zm0 1.823V12c0 .426.316.917 1.06 1.33.727.405 1.765.67 2.94.67 1.174 0 2.212-.265 2.939-.67.744-.413 1.06-.904 1.06-1.33V9.823a4.203 4.203 0 0 1-.575.382c-.901.5-2.113.795-3.425.795-1.31 0-2.523-.294-3.424-.795A4.205 4.205 0 0 1 4 9.823Z",
        clipRule: "evenodd"
      }
    )
  }
), U4 = t(t5), n5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.307 3.899a.5.5 0 0 0-.807.395v5.786a.5.5 0 0 0 .225.418l3 1.973a.5.5 0 0 0 .55 0l3-1.973a.5.5 0 0 0 .225-.418V4.294a.5.5 0 0 0-.807-.395l-2.08 1.616a1 1 0 0 1-1.227 0l-2.08-1.616ZM3.5 4.294c0-1.248 1.435-1.95 2.42-1.185L8 4.725l2.08-1.616c.985-.766 2.42-.063 2.42 1.185v5.786a1.5 1.5 0 0 1-.676 1.254l-3 1.972a1.5 1.5 0 0 1-1.648 0l-3-1.972A1.5 1.5 0 0 1 3.5 10.08V4.294Z",
        clipRule: "evenodd"
      }
    )
  }
), Y4 = t(n5), r5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "#D64328",
        fillRule: "evenodd",
        d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-9.6L4.8 3.84v5.453c0 .098.022.19.067.274a.76.76 0 0 0 .173.22L8 12.16l2.96-2.373a.76.76 0 0 0 .173-.22.578.578 0 0 0 .067-.274V3.84L8 6.4Z",
        clipRule: "evenodd"
      }
    )
  }
), G4 = t(r5), s5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "#161B27",
        fillRule: "evenodd",
        d: "M4 3.429c0-.316.256-.572.571-.572h4.572v2.286a.571.571 0 0 0 .571.571H12v6.857a.571.571 0 0 1-.571.572H4.57A.571.571 0 0 1 4 12.57V3.43Zm7.192 1.142-.906-.906v.906h.906Zm-6.62-2.857c-.947 0-1.715.768-1.715 1.715v9.142c0 .947.768 1.715 1.714 1.715h6.858c.946 0 1.714-.768 1.714-1.715V5.616c0-.454-.18-.89-.502-1.212l-2.188-2.188a1.714 1.714 0 0 0-1.212-.502H4.57Zm.57 7.429c0-.316.257-.572.572-.572H7.43V6.857a.571.571 0 1 1 1.142 0v1.714h1.715a.571.571 0 1 1 0 1.143H8.57v1.714a.571.571 0 1 1-1.142 0V9.714H5.714a.571.571 0 0 1-.571-.571Z",
        clipRule: "evenodd"
      }
    )
  }
), q4 = t(s5), c5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.354 5.146a.5.5 0 0 1 0 .708l-6.25 6.25a.5.5 0 0 1-.708 0l-3.25-3.25a.5.5 0 1 1 .708-.708l2.896 2.897 5.896-5.897a.5.5 0 0 1 .708 0Z",
        clipRule: "evenodd"
      }
    )
  }
), J4 = t(c5), h5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx("circle", { cx: 10, cy: 10, r: 3.125, fill: "currentColor" })
  }
), X4 = t(h5), i5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M20 15v4c0 .276-.111.525-.293.707S19.276 20 19 20H5c-.276 0-.525-.111-.707-.293S4 19.276 4 19v-4a1 1 0 0 0-2 0v4a2.997 2.997 0 0 0 3 3h14a2.997 2.997 0 0 0 3-3v-4a1 1 0 0 0-2 0zm-7-2.414V3a1 1 0 0 0-2 0v9.586L7.707 9.293a.999.999 0 1 0-1.414 1.414l5 5A1.008 1.008 0 0 0 12 16a.997.997 0 0 0 .707-.293l5-5a.999.999 0 1 0-1.414-1.414z" }) }), K4 = t(i5), v5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6.188 13.813h1.77l4.417-4.417-1.77-1.75-4.418 4.396v1.77Zm6.77-5 .646-.646a.73.73 0 0 0 0-1.063l-.708-.708a.729.729 0 0 0-1.063 0l-.646.646 1.771 1.77ZM10 18a7.796 7.796 0 0 1-3.104-.625 8.064 8.064 0 0 1-2.552-1.719 8.063 8.063 0 0 1-1.719-2.552A7.797 7.797 0 0 1 2 10c0-1.111.208-2.15.625-3.115a8.064 8.064 0 0 1 4.27-4.26A7.797 7.797 0 0 1 10 2c1.111 0 2.15.208 3.115.625a8.095 8.095 0 0 1 4.26 4.26C17.792 7.851 18 8.89 18 10a7.797 7.797 0 0 1-.625 3.104 8.063 8.063 0 0 1-4.26 4.271A7.774 7.774 0 0 1 10 18Zm0-1.5c1.806 0 3.34-.632 4.604-1.896C15.868 13.34 16.5 11.806 16.5 10s-.632-3.34-1.896-4.604C13.34 4.132 11.806 3.5 10 3.5s-3.34.632-4.604 1.896C4.132 6.66 3.5 8.194 3.5 10s.632 3.34 1.896 4.604C6.66 15.868 8.194 16.5 10 16.5Z"
      }
    )
  }
), Q4 = t(v5), d5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.354 3.147a1.914 1.914 0 0 0-2.708 0L4.904 8.889a.484.484 0 0 0-.015.015l-1.743 1.743a.5.5 0 0 0-.136.255l-.5 2.5a.5.5 0 0 0 .588.588l2.5-.5a.5.5 0 0 0 .256-.136l1.741-1.742a.437.437 0 0 0 .017-.017L12.6 6.606l.005-.005.748-.747a1.914 1.914 0 0 0 0-2.707Zm-9.393 8.1 1.152-1.153.19.38a.5.5 0 0 0 .447.276h.691l.2.401-1.388 1.389-.733.146-.318-.317-.071-.071-.317-.317.147-.734Zm3.236-1.22.19.38 4.35-4.351a1.5 1.5 0 0 0-1.292-1.293L5.858 9.349l.201.401h.691a.5.5 0 0 1 .447.277Zm5.345-4.776.104-.104a.914.914 0 1 0-1.293-1.293l-.104.104a2.51 2.51 0 0 1 1.293 1.293Z",
        clipRule: "evenodd"
      }
    )
  }
), e3 = t(d5), w5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.976 2.216a1.714 1.714 0 0 1 1.212-.502h3.624c.455 0 .891.18 1.213.502l2.759 2.76c.321.32.502.757.502 1.211v3.625c0 .455-.18.89-.502 1.212l-2.76 2.76a1.714 1.714 0 0 1-1.212.501H6.188c-.455 0-.891-.18-1.212-.502l-2.76-2.759a1.714 1.714 0 0 1-.502-1.212V6.187c0-.454.18-.89.502-1.212l2.76-2.759Zm3.602 8.355a.571.571 0 0 1-.571.571H8A.571.571 0 1 1 8 10h.007c.315 0 .571.255.571.571ZM8 9.428a.571.571 0 0 1-.571-.571V5.428a.571.571 0 0 1 1.142 0v3.429A.571.571 0 0 1 8 9.428Z",
        clipRule: "evenodd"
      }
    )
  }
), a3 = t(w5), g5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 8V4.707l1.146 1.147a.5.5 0 1 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L3 4.707v6.586l-1.146-1.147a.5.5 0 0 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L4 11.293V8Zm3.5-3.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM7 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 7 8Zm.5 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z",
        clipRule: "evenodd"
      }
    )
  }
), o3 = t(g5), m5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.638 5.923a.714.714 0 1 0 1.01 1.01L10 4.581l2.352 2.352a.714.714 0 1 0 1.01-1.01l-2.857-2.857a.714.714 0 0 0-1.01 0L6.638 5.923Zm0 8.153a.714.714 0 1 1 1.01-1.01L10 15.418l2.352-2.352a.714.714 0 1 1 1.01 1.01l-2.857 2.858a.714.714 0 0 1-1.01 0l-2.857-2.858Z",
        clipRule: "evenodd"
      }
    )
  }
), l3 = t(m5), f5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M.106 11.553a.997.997 0 0 0 0 .894s.396.789 1.12 1.843a20.553 20.553 0 0 0 1.757 2.218c.894.979 2.004 1.987 3.319 2.8C7.897 20.294 9.808 21 12 21s4.103-.706 5.698-1.692c1.315-.813 2.425-1.821 3.319-2.8a20.678 20.678 0 0 0 1.757-2.218 17.468 17.468 0 0 0 1.12-1.843.997.997 0 0 0 0-.894s-.396-.789-1.12-1.843a20.553 20.553 0 0 0-1.757-2.218c-.894-.979-2.004-1.987-3.319-2.8C16.103 3.706 14.192 3 12 3s-4.103.706-5.698 1.692c-1.315.813-2.425 1.821-3.319 2.8A20.455 20.455 0 0 0 1.226 9.71a17.468 17.468 0 0 0-1.12 1.843zM2.14 12a18.575 18.575 0 0 1 2.319-3.159c.805-.881 1.775-1.756 2.894-2.448C8.703 5.559 10.254 5 12 5s3.297.559 4.646 1.393c1.119.692 2.089 1.567 2.894 2.448A18.701 18.701 0 0 1 21.859 12a18.575 18.575 0 0 1-2.319 3.159c-.805.881-1.775 1.756-2.894 2.448C15.297 18.441 13.746 19 12 19s-3.297-.559-4.646-1.393c-1.119-.692-2.089-1.567-2.894-2.448A18.701 18.701 0 0 1 2.14 12zM16 12c0-1.104-.449-2.106-1.172-2.828a3.994 3.994 0 0 0-5.656 0 3.994 3.994 0 0 0 0 5.656 3.994 3.994 0 0 0 5.656 0A3.994 3.994 0 0 0 16 12zm-2 0c0 .553-.223 1.051-.586 1.414S12.553 14 12 14s-1.051-.223-1.414-.586S10 12.553 10 12s.223-1.051.586-1.414S11.447 10 12 10s1.051.223 1.414.586S14 11.447 14 12z" }) }), t3 = t(f5), u5 = (o, a) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 18",
    ref: a,
    ...o,
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M19.459 17.07v-3.687c0-2.864 1.315-4.718 3.987-4.718.19 0 .445 0 .615.021l.149-2.106c-.276-.084-.488-.084-.743-.084-1.824 0-3.16.969-4.008 2.359V6.622h-2.206V17.07h2.206ZM29.587 17.348c3.093 0 5.613-2.245 5.613-5.506 0-3.262-2.52-5.486-5.613-5.486-3.114 0-5.656 2.224-5.656 5.486 0 3.261 2.542 5.506 5.656 5.506Zm0-1.906c-1.843 0-3.496-1.419-3.496-3.6 0-2.182 1.653-3.6 3.496-3.6 1.8 0 3.474 1.418 3.474 3.6 0 2.181-1.674 3.6-3.474 3.6ZM10.07 17.348c1.623 0 2.784-.63 3.564-1.49v1.196h2.088v-6.775c0-2.518-1.772-3.923-4.45-3.923H0v1.909h11.398c1.329 0 2.236.839 2.236 2.181v.315h-3.27c-2.699 0-4.197 1.342-4.197 3.293s1.561 3.293 3.902 3.293Zm.337-1.762c-1.287 0-2.13-.63-2.13-1.574 0-.923.759-1.573 2.046-1.573h3.311v.336c0 1.594-1.476 2.81-3.227 2.81Z"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4.719 17.07V4.44c0-1.157.723-1.83 1.83-1.83.34 0 .745.063 1.128.21l.532-1.79A4.352 4.352 0 0 0 6.4.653C4.06.652 2.505 2.104 2.505 4.44V17.07h2.214Z"
        }
      )
    ]
  }
), n3 = t(u5), x5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "#161B27",
        fillRule: "evenodd",
        d: "M8 2a6 6 0 0 0-.246 11.995c.246.367.543.696.882.977a7 7 0 1 1 6.335-6.335c-.28-.34-.609-.637-.976-.883A6 6 0 0 0 8 2Zm3.5 5a4.6 4.6 0 0 1 .184.004C11.883 6.72 12 6.374 12 6V4.5a.5.5 0 0 0-1 0V6a.748.748 0 0 1-.25.559V4a.5.5 0 0 0-1 0v2.559A.748.748 0 0 1 9.5 6V4.5a.5.5 0 0 0-1 0V6c0 .654.359 1.224.89 1.524A4.48 4.48 0 0 1 11.5 7ZM5 5.25a.75.75 0 0 1 1.5 0V6A.75.75 0 0 1 5 6v-.75Zm.75-1.75A1.75 1.75 0 0 0 4 5.25V6a1.75 1.75 0 0 0 1.25 1.678V12a.5.5 0 0 0 1 0V7.678A1.75 1.75 0 0 0 7.5 6v-.75A1.75 1.75 0 0 0 5.75 3.5Zm3.25 8a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM11.5 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm1.354 2.854a.5.5 0 0 0-.708-.708l-.646.647-.646-.647a.5.5 0 0 0-.708.708l.647.646-.647.646a.5.5 0 0 0 .708.708l.646-.647.646.647a.5.5 0 0 0 .708-.708l-.647-.646.647-.646Z",
        clipRule: "evenodd"
      }
    )
  }
), r3 = t(x5), p5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M14 1H6a2.997 2.997 0 0 0-3 3v16a2.997 2.997 0 0 0 3 3h12a2.997 2.997 0 0 0 3-3V8a.997.997 0 0 0-.293-.707l-6-6A.998.998 0 0 0 14 1zm3.586 6H15V4.414zM13 3v5a1 1 0 0 0 1 1h5v11c0 .276-.111.525-.293.707S18.276 21 18 21H6c-.276 0-.525-.111-.707-.293S5 20.276 5 20V4c0-.276.111-.525.293-.707S5.724 3 6 3zm3 9H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm0 4H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-6-8H8a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z" }) }), s3 = t(p5), R5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.276 4.571A1.142 1.142 0 1 1 11.429 4v.003c-.001.207-.057.401-.153.568Zm1.223 0a2.287 2.287 0 0 1-4.427 0H2.286a.571.571 0 0 1 0-1.142h5.786a2.287 2.287 0 0 1 4.427 0h1.215a.571.571 0 0 1 0 1.142H12.5Zm-1.223 8a1.142 1.142 0 0 1-1.98 0l-.006-.009-.01-.017a1.138 1.138 0 0 1 .016-1.117 1.142 1.142 0 0 1 2.133.572v.004c-.001.207-.057.4-.153.567Zm1.223 0a2.287 2.287 0 0 1-4.427 0H2.286a.571.571 0 1 1 0-1.143h5.786a2.287 2.287 0 0 1 4.427 0h1.215a.571.571 0 0 1 0 1.143H12.5ZM5.714 9.143a1.142 1.142 0 1 0 .001-2.285 1.142 1.142 0 0 0 0 2.285Zm0 1.143c1.065 0 1.96-.729 2.214-1.715h5.786a.571.571 0 0 0 0-1.142H7.928a2.287 2.287 0 0 0-4.427 0H2.286a.571.571 0 0 0 0 1.142H3.5a2.287 2.287 0 0 0 2.213 1.715Z",
        clipRule: "evenodd"
      }
    )
  }
), c3 = t(R5), Z5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.98 2.751c.107.26.163.539.163.82h2.143c1.183 0 2.143.96 2.143 2.143v10c0 1.184-.96 2.143-2.143 2.143H5.714a2.143 2.143 0 0 1-2.143-2.143v-10c0-1.183.96-2.143 2.143-2.143h2.143a2.143 2.143 0 0 1 4.123-.82ZM5 5.714C5 5.32 5.32 5 5.714 5h8.572c.394 0 .714.32.714.714v10c0 .395-.32.715-.714.715H5.714A.714.714 0 0 1 5 15.714v-10Zm1.429 2.143c0-.394.32-.714.714-.714h3.571a.714.714 0 1 1 0 1.428H7.143a.714.714 0 0 1-.714-.714ZM7.143 10a.714.714 0 0 0 0 1.429h5.714a.714.714 0 0 0 0-1.429H7.143Zm-.714 3.571c0-.394.32-.714.714-.714h5.714a.714.714 0 0 1 0 1.429H7.143a.714.714 0 0 1-.714-.715ZM10 3.93A.714.714 0 1 0 10 2.5a.714.714 0 0 0 0 1.429Z",
        clipRule: "evenodd"
      }
    )
  }
), h3 = t(Z5), j5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2.5c-.171 0-.38.081-.617.322-.24.244-.478.62-.69 1.128a8.737 8.737 0 0 0-.518 1.884c1.21.172 2.44.172 3.65 0a8.737 8.737 0 0 0-.519-1.884c-.21-.507-.45-.884-.69-1.128C8.38 2.582 8.172 2.5 8 2.5ZM5.77 3.565a9.71 9.71 0 0 0-.58 2.09c-.63-.14-1.251-.327-1.86-.562a5.517 5.517 0 0 1 2.81-2.27 5.835 5.835 0 0 0-.37.742ZM5.062 6.65c-.74-.16-1.47-.38-2.182-.66a5.486 5.486 0 0 0-.35 2.577c.826.281 1.669.496 2.52.647a14.774 14.774 0 0 1 .012-2.564Zm.114 3.598a17.99 17.99 0 0 1-2.41-.554 5.515 5.515 0 0 0 3.375 3.484 5.832 5.832 0 0 1-.37-.743 9.815 9.815 0 0 1-.595-2.187Zm1.038.135c1.188.118 2.386.118 3.574 0a8.47 8.47 0 0 1-.48 1.667c-.212.507-.45.884-.69 1.128-.238.24-.446.322-.617.322-.171 0-.38-.081-.617-.322-.24-.244-.478-.62-.69-1.128a8.47 8.47 0 0 1-.48-1.667Zm3.72-1.022a17.005 17.005 0 0 1-3.866 0 13.647 13.647 0 0 1-.017-2.535c1.293.183 2.607.183 3.9 0a13.749 13.749 0 0 1-.017 2.535Zm.892.887a9.812 9.812 0 0 1-.596 2.187c-.11.266-.234.515-.37.743a5.515 5.515 0 0 0 3.375-3.484c-.792.24-1.597.425-2.409.554Zm2.646-1.68c-.826.28-1.669.495-2.52.646a14.774 14.774 0 0 0-.012-2.564c.74-.16 1.47-.38 2.182-.66a5.486 5.486 0 0 1 .35 2.577ZM9.86 2.821a5.517 5.517 0 0 1 2.81 2.27 12.96 12.96 0 0 1-1.86.563 9.71 9.71 0 0 0-.58-2.09 5.838 5.838 0 0 0-.37-.743ZM8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z",
        clipRule: "evenodd"
      }
    )
  }
), i3 = t(j5), A5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.006 18a7.81 7.81 0 0 1-3.11-.625 8.064 8.064 0 0 1-2.552-1.719 8.065 8.065 0 0 1-1.719-2.551A7.818 7.818 0 0 1 2 9.99c0-1.104.208-2.14.625-3.105a8.066 8.066 0 0 1 4.27-4.26A7.818 7.818 0 0 1 10.009 2a7.75 7.75 0 0 1 3.106.625 8.082 8.082 0 0 1 4.26 4.265A7.77 7.77 0 0 1 18 9.994a7.81 7.81 0 0 1-.625 3.11 8.063 8.063 0 0 1-1.719 2.552 8.08 8.08 0 0 1-2.546 1.719 7.77 7.77 0 0 1-3.104.625ZM9 16.417V15a.961.961 0 0 1-.708-.294A.967.967 0 0 1 8 14v-1L3.646 8.646A6.516 6.516 0 0 0 3.5 10c0 1.597.517 3.007 1.552 4.23C6.087 15.45 7.402 16.18 9 16.416Zm6-2.271c.25-.292.469-.597.656-.917.188-.32.343-.656.466-1.011.123-.355.217-.72.281-1.094.065-.374.097-.749.097-1.124a6.364 6.364 0 0 0-1.083-3.6A6.404 6.404 0 0 0 12.5 4v.5c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44H9v1c0 .283-.096.52-.287.713A.968.968 0 0 1 8 8H7v2h5c.283 0 .52.096.713.287.191.192.287.43.287.713v2h.854c.32 0 .59.111.813.333.222.223.333.493.333.813Z"
      }
    )
  }
), v3 = t(A5), M5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.286 2.857c-1.184 0-2.143.96-2.143 2.143v2.143c0 1.183.96 2.143 2.143 2.143h2.857c1.183 0 2.143-.96 2.143-2.143V5c0-1.183-.96-2.143-2.143-2.143H4.286ZM3.57 5c0-.394.32-.714.715-.714h2.857c.394 0 .714.32.714.714v2.143c0 .394-.32.714-.714.714H4.286a.714.714 0 0 1-.715-.714V5Zm.715 5.714c-1.184 0-2.143.96-2.143 2.143V15c0 1.183.96 2.143 2.143 2.143h2.857c1.183 0 2.143-.96 2.143-2.143v-2.143c0-1.183-.96-2.143-2.143-2.143H4.286Zm-.715 2.143c0-.394.32-.714.715-.714h2.857c.394 0 .714.32.714.714V15c0 .394-.32.714-.714.714H4.286A.714.714 0 0 1 3.57 15v-2.143Zm7.143 0c0-1.183.96-2.143 2.143-2.143h2.857c1.184 0 2.143.96 2.143 2.143V15c0 1.183-.96 2.143-2.143 2.143h-2.857A2.143 2.143 0 0 1 10.714 15v-2.143Zm2.143-.714a.714.714 0 0 0-.714.714V15c0 .394.32.714.714.714h2.857c.395 0 .715-.32.715-.714v-2.143a.714.714 0 0 0-.715-.714h-2.857Zm0-9.286c-1.183 0-2.143.96-2.143 2.143v2.143c0 1.183.96 2.143 2.143 2.143h2.857c1.184 0 2.143-.96 2.143-2.143V5c0-1.183-.96-2.143-2.143-2.143h-2.857ZM12.143 5c0-.394.32-.714.714-.714h2.857c.395 0 .715.32.715.714v2.143c0 .394-.32.714-.715.714h-2.857a.714.714 0 0 1-.714-.714V5Z",
        clipRule: "evenodd"
      }
    )
  }
), d3 = t(M5), V5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.5 3a1 1 0 0 1 1-1H10a.5.5 0 0 0 0-1H4.5a2 2 0 1 0 0 4h3.75a.5.5 0 0 0 0-1H4.5a1 1 0 0 1-1-1Zm1 4a1 1 0 0 0 0 2H11a1.5 1.5 0 0 0 1.5-1.5v-.25a.5.5 0 0 1 1 0v.25A2.5 2.5 0 0 1 11 10H4.5a2 2 0 1 1 0-4h6a.5.5 0 0 1 0 1h-6Zm0 5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Zm-2 1a2 2 0 0 1 2-2h7a2 2 0 1 1 0 4h-7a2 2 0 0 1-2-2Zm7-9.5A.5.5 0 0 1 10 3h1.5V1.5a.5.5 0 0 1 1 0V3H14a.5.5 0 0 1 0 1h-1.5v1.5a.5.5 0 0 1-1 0V4H10a.5.5 0 0 1-.5-.5Z",
        clipRule: "evenodd"
      }
    )
  }
), w3 = t(V5), H5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M10 2.8a3 3 0 0 1 3 3v.02a3 3 0 1 1-6 0V5.8a3 3 0 0 1 3-3zM10 13.2a3 3 0 0 1 3 3v.02a3 3 0 1 1-6 0v-.02a3 3 0 0 1 3-3zM22 2.8a3 3 0 0 1 3 3v.02a3 3 0 1 1-6 0V5.8a3 3 0 0 1 3-3zM22 13.2a3 3 0 0 1 3 3v.02a3 3 0 1 1-6 0v-.02a3 3 0 0 1 3-3zM10 23.2a3 3 0 0 1 3 3v.02a3 3 0 1 1-6 0v-.02a3 3 0 0 1 3-3zM22 23.2a3 3 0 0 1 3 3v.02a3 3 0 1 1-6 0v-.02a3 3 0 0 1 3-3z" }) }), g3 = t(H5), S5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 5Zm0 3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8Zm.5 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z",
        clipRule: "evenodd"
      }
    )
  }
), m3 = t(S5), C5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "#8854F9",
        fillRule: "evenodd",
        d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM4.667 4.333a1 1 0 1 0 0 2h6.666a1 1 0 1 0 0-2H4.667ZM3.667 8a1 1 0 0 1 1-1h6.666a1 1 0 1 1 0 2H4.667a1 1 0 0 1-1-1Zm1 1.667a1 1 0 0 0 0 2h6.666a1 1 0 1 0 0-2H4.667Z",
        clipRule: "evenodd"
      }
    )
  }
), f3 = t(C5), F5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 13.143A5.143 5.143 0 1 1 8 2.857a5.143 5.143 0 0 1 0 10.286ZM1.714 8a6.286 6.286 0 1 1 12.572 0A6.286 6.286 0 0 1 1.714 8ZM8.571 4.57a.571.571 0 0 0-1.142 0V8c0 .216.122.414.316.511l2.285 1.143a.571.571 0 0 0 .511-1.022l-1.97-.985V4.57Z",
        clipRule: "evenodd"
      }
    )
  }
), u3 = t(F5), I5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M8 25.333h4v-8h8v8h4v-12l-8-6-8 6v12zM8 28c-.733 0-1.361-.261-1.883-.783s-.784-1.151-.784-1.884v-12c0-.422.095-.822.284-1.2s.449-.689.783-.933l8-6c.244-.178.5-.311.767-.4s.544-.133.833-.133c.289 0 .567.044.833.133s.522.222.767.4l8 6c.333.244.595.556.784.933s.283.778.283 1.2v12c0 .733-.261 1.361-.783 1.884S24.733 28 24 28h-6.667v-8h-2.667v8H7.999z" }) }), x3 = t(I5), B5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667zm-2.667 20L6.666 16l1.88-1.88 4.787 4.773 10.12-10.12 1.88 1.893-12 12z" }) }), p3 = t(B5), $5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M4 23v5h5l14.747-14.747-5-5L4 23zM27.613 9.387c.52-.52.52-1.36 0-1.88l-3.12-3.12c-.52-.52-1.36-.52-1.88 0l-2.44 2.44 5 5 2.44-2.44z" }) }), R3 = t($5), L5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M16 2.667C8.633 2.667 2.667 8.634 2.667 16S8.634 29.333 16 29.333 29.333 23.366 29.333 16 23.366 2.667 16 2.667zm1.333 20h-2.667v-8h2.667v8zm0-10.667h-2.667V9.333h2.667V12z" }) }), Z3 = t(L5), b5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "#161B27",
        fillRule: "evenodd",
        d: "M3.572 5c0-1.183.959-2.143 2.143-2.143h5.245c.947 0 1.855.376 2.525 1.046l1.898 1.898a3.571 3.571 0 0 1 1.046 2.525V15c0 1.183-.96 2.143-2.143 2.143H5.714A2.143 2.143 0 0 1 3.572 15v-1.786a.714.714 0 1 1 1.428 0V15c0 .395.32.714.715.714h8.57c.395 0 .715-.32.715-.714V8.664l-.175.038c-2.534.543-4.784-1.708-4.24-4.24l.037-.176H5.715A.714.714 0 0 0 5 5v3.071a.714.714 0 0 1-1.428 0V5Zm10.8 1.811c.137.136.252.288.346.453l-.193.04a2.143 2.143 0 0 1-2.544-2.543l.041-.193c.164.094.317.21.453.345l1.898 1.898Zm-2.438 3.398L9.077 7.352a.714.714 0 1 0-1.01 1.01L9.704 10H2.857a.714.714 0 0 0 0 1.428h6.847l-1.637 1.638a.714.714 0 0 0 1.01 1.01l2.857-2.857a.714.714 0 0 0 0-1.01Z",
        clipRule: "evenodd"
      }
    )
  }
), j3 = t(b5), E5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 8 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M8 24v8H0v-8h8zM8 0v17.333H0V0h8z" }) }), A3 = t(E5), y5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4.047a1.5 1.5 0 0 1 1.5-1.5h7a1.5 1.5 0 0 1 0 3h-7a1.5 1.5 0 0 1-1.5-1.5Zm1.5-.5a.5.5 0 1 0 0 1h7a.5.5 0 0 0 0-1h-7ZM3 8.047a1.5 1.5 0 0 1 1.5-1.5h7a1.5 1.5 0 0 1 0 3h-7a1.5 1.5 0 0 1-1.5-1.5Zm1.5-.5a.5.5 0 1 0 0 1h7a.5.5 0 0 0 0-1h-7Zm4 3a1.5 1.5 0 1 0 0 3h3a1.5 1.5 0 0 0 0-3h-3Zm0 1h3a.5.5 0 1 1 0 1h-3a.5.5 0 0 1 0-1Zm-4.353-.853a.5.5 0 0 1 .707 0l1 1a.5.5 0 0 1 0 .707l-1 1a.5.5 0 1 1-.707-.707l.146-.146H3.5a2.5 2.5 0 0 1-2.5-2.5.5.5 0 0 1 1 0 1.5 1.5 0 0 0 1.5 1.5h.793l-.146-.147a.5.5 0 0 1 0-.707Z",
        clipRule: "evenodd"
      }
    )
  }
), M3 = t(y5), z5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4.047a1.5 1.5 0 0 1 1.5-1.5h7a1.5 1.5 0 0 1 0 3h-7a1.5 1.5 0 0 1-1.5-1.5Zm1.5-.5a.5.5 0 1 0 0 1h7a.5.5 0 0 0 0-1h-7Zm-1.5 8.5a1.5 1.5 0 0 1 1.5-1.5h7a1.5 1.5 0 0 1 0 3h-7a1.5 1.5 0 0 1-1.5-1.5Zm1.5-.5a.5.5 0 1 0 0 1h7a.5.5 0 0 0 0-1h-7Zm4-5a1.5 1.5 0 1 0 0 3h3a1.5 1.5 0 0 0 0-3h-3Zm-.5 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4.147 6.694a.5.5 0 0 1 .707 0l1 1a.5.5 0 0 1 0 .707l-1 1a.5.5 0 0 1-.707-.707l.146-.146H3.5a2.5 2.5 0 0 1-2.5-2.5.5.5 0 0 1 1 0 1.5 1.5 0 0 0 1.5 1.5h.793L4.147 7.4a.5.5 0 0 1 0-.707Z",
        clipRule: "evenodd"
      }
    )
  }
), V3 = t(z5), _5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.286 6.071a.714.714 0 0 0-.715.714v6.429c0 .394.32.714.715.714h8.66c.2 0 .39-.083.525-.23l2.967-3.214a.714.714 0 0 0 0-.969L13.47 6.301a.714.714 0 0 0-.525-.23h-8.66Zm-2.143.714c0-1.183.96-2.142 2.143-2.142h8.66c.598 0 1.169.25 1.575.689l2.967 3.214c.757.821.757 2.086 0 2.907l-2.967 3.215c-.406.439-.977.689-1.575.689h-8.66a2.143 2.143 0 0 1-2.143-2.143V6.785Z",
        clipRule: "evenodd"
      }
    )
  }
), H3 = t(_5), T5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M14.016 3H21v6.984h-2.016V6.421l-9.797 9.797-1.406-1.406 9.797-9.797h-3.563V2.999zm4.968 15.984V12H21v6.984q0 .797-.609 1.406t-1.406.609H5.016q-.844 0-1.43-.586T3 18.983V5.014q0-.844.586-1.43t1.43-.586H12v2.016H5.016v13.969h13.969z" }) }), S3 = t(T5), P5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M12 3.118 19.764 7 12 10.882 4.236 7zm-.447-2.012-10 5a1 1 0 0 0 0 1.788l10 5c.292.146.62.136.894 0l10-5a1 1 0 0 0 0-1.789l-10-5a.997.997 0 0 0-.894 0zm-10 16.788 10 5c.292.146.62.136.894 0l10-5a1 1 0 0 0-.895-1.789L12 20.882l-9.553-4.776a1 1 0 0 0-.895 1.789zm0-5 10 5c.292.146.62.136.894 0l10-5a1 1 0 0 0-.895-1.789L12 15.882l-9.553-4.776a1 1 0 0 0-.895 1.789z" }) }), C3 = t(P5), k5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "#161B27",
        fillRule: "evenodd",
        d: "M5 1.5a.5.5 0 0 1 .5.5h5a.5.5 0 0 1 1 0A2.5 2.5 0 0 1 14 4.5V8a.5.5 0 0 1-1 0V6H3v5.5A1.5 1.5 0 0 0 4.5 13H8a.5.5 0 0 1 0 1H4.5A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2a.5.5 0 0 1 .5-.5ZM10.5 3a.5.5 0 0 0 1 0A1.5 1.5 0 0 1 13 4.5V5H3v-.5A1.5 1.5 0 0 1 4.5 3a.5.5 0 0 0 1 0h5ZM6 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-.5 3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm3-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM8 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm3-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-2 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 .5a.5.5 0 0 1 .5.5v.793l.354.353a.5.5 0 0 1-.708.708l-.5-.5A.5.5 0 0 1 11.5 12v-1a.5.5 0 0 1 .5-.5Z",
        clipRule: "evenodd"
      }
    )
  }
), F3 = t(k5), O5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 2.5a2.496 2.496 0 0 0-2-1h-.5A2.5 2.5 0 0 0 3 4v-.45A2.5 2.5 0 0 0 1 6v5a2.5 2.5 0 0 0 2.5 2.5h9A2.5 2.5 0 0 0 15 11V6a2.5 2.5 0 0 0-2.042-2.458A2.5 2.5 0 0 0 10.5 1.5H10c-.818 0-1.544.393-2 1Zm-.5 8.768V4A1.5 1.5 0 0 0 6 2.5h-.5A1.5 1.5 0 0 0 4 4v5.5A1.5 1.5 0 0 0 5.5 11h1c.364 0 .706.097 1 .268ZM8.5 4v7.268a1.99 1.99 0 0 1 1-.268h1A1.5 1.5 0 0 0 12 9.5V4a1.5 1.5 0 0 0-1.5-1.5H10A1.5 1.5 0 0 0 8.5 4Zm-1.134 8.5H3.5A1.5 1.5 0 0 1 2 11V6a1.5 1.5 0 0 1 1-1.415V9.5A2.5 2.5 0 0 0 5.5 12h1a1 1 0 0 1 .866.5Zm5.134 0H8.634A1 1 0 0 1 9.5 12h1A2.5 2.5 0 0 0 13 9.5V4.585A1.5 1.5 0 0 1 14 6v5a1.5 1.5 0 0 1-1.5 1.5Z",
        clipRule: "evenodd"
      }
    )
  }
), I3 = t(O5), D5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M7.2 11.2H4.8c-.885 0-1.64-.313-2.264-.937A3.09 3.09 0 0 1 1.6 7.996c0-.886.312-1.64.936-2.263A3.089 3.089 0 0 1 4.8 4.8h2.4V6H4.8c-.556 0-1.028.194-1.417.583A1.929 1.929 0 0 0 2.8 8c0 .555.194 1.028.583 1.416.39.39.861.584 1.417.584h2.4v1.2ZM5.6 8.6V7.4h4.8v1.2H5.6Zm3.2 2.6V10h2.4c.556 0 1.028-.195 1.417-.584.388-.388.583-.86.583-1.416 0-.556-.194-1.028-.583-1.417A1.929 1.929 0 0 0 11.2 6H8.8V4.8h2.4c.885 0 1.64.312 2.264.937a3.09 3.09 0 0 1 .936 2.267c0 .886-.312 1.64-.936 2.263a3.089 3.089 0 0 1-2.264.933H8.8Z"
      }
    )
  }
), B3 = t(D5), W5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm2.5.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 7a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6ZM6 8a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6A.5.5 0 0 1 6 8Zm-3 3.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM4 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        clipRule: "evenodd"
      }
    )
  }
), $3 = t(W5), N5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 28 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M28.308 0v16H0zM19.692 32V20.923H0z" }) }), L3 = t(N5), U5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.857 5.714c0-1.183.96-2.142 2.143-2.142h6.428c1.184 0 2.143.959 2.143 2.142v1.429a.714.714 0 0 1-1.428 0V5.714A.714.714 0 0 0 11.428 5H6.261l1.945 1.111a2.143 2.143 0 0 1 1.08 1.861V15h2.143c.394 0 .714-.32.714-.714v-1.429a.714.714 0 0 1 1.428 0v1.429c0 1.183-.959 2.143-2.143 2.143H9.287a.69.69 0 0 1-.063-.003c-.318 1.284-1.777 2.024-3.038 1.394l-2.143-1.072a2.143 2.143 0 0 1-1.185-1.917V5.714Zm1.429 6.429V6.748a.714.714 0 0 1 1.068-.62l2.143 1.224c.223.127.36.364.36.62v7.93a.714.714 0 0 1-1.034.64L4.681 15.47a.714.714 0 0 1-.395-.639v-2.688Zm13.362-1.638-2.143 2.143a.714.714 0 1 1-1.01-1.01l.923-.924h-3.99a.714.714 0 0 1 0-1.428h3.99l-.923-.924a.714.714 0 0 1 1.01-1.01l2.143 2.143a.714.714 0 0 1 0 1.01Z",
        clipRule: "evenodd"
      }
    )
  }
), b3 = t(U5), Y5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "m18.586 4-5.293 5.293a.999.999 0 1 0 1.414 1.414L20 5.414V9a1 1 0 0 0 2 0V3a.995.995 0 0 0-.292-.706l-.002-.002A.996.996 0 0 0 21 2h-6a1 1 0 0 0 0 2zM5.414 20l5.293-5.293a.999.999 0 1 0-1.414-1.414L4 18.586V15a1 1 0 0 0-2 0v6a.995.995 0 0 0 .292.706l.002.002A.996.996 0 0 0 3 22h6a1 1 0 0 0 0-2z" }) }), E3 = t(Y5), G5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M8 2H5a2.997 2.997 0 0 0-3 3v3a1 1 0 0 0 2 0V5c0-.276.111-.525.293-.707S4.724 4 5 4h3a1 1 0 0 0 0-2zm14 6V5a2.997 2.997 0 0 0-3-3h-3a1 1 0 0 0 0 2h3c.276 0 .525.111.707.293S20 4.724 20 5v3a1 1 0 0 0 2 0zm-6 14h3a2.997 2.997 0 0 0 3-3v-3a1 1 0 0 0-2 0v3c0 .276-.111.525-.293.707S19.276 20 19 20h-3a1 1 0 0 0 0 2zM2 16v3a2.997 2.997 0 0 0 3 3h3a1 1 0 0 0 0-2H5c-.276 0-.525-.111-.707-.293S4 19.276 4 19v-3a1 1 0 0 0-2 0z" }) }), y3 = t(G5), q5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M23 12c0-3.037-1.232-5.789-3.222-7.778S15.037 1 12 1 6.211 2.232 4.222 4.222 1 8.963 1 12s1.232 5.789 3.222 7.778S8.963 23 12 23s5.789-1.232 7.778-3.222S23 15.037 23 12zm-2 0c0 2.486-1.006 4.734-2.636 6.364S14.486 21 12 21s-4.734-1.006-6.364-2.636S3 14.486 3 12s1.006-4.734 2.636-6.364S9.514 3 12 3s4.734 1.006 6.364 2.636S21 9.514 21 12zM8 13h8a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2z" }) }), z3 = t(q5), J5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2.5, d: "M5 12h14" }) }), _3 = t(J5), X5 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M14 12c0-.552-.225-1.053-.586-1.414a1.996 1.996 0 0 0-2.828 0 1.996 1.996 0 0 0 0 2.828 1.996 1.996 0 0 0 2.828 0c.361-.361.586-.862.586-1.414zm7 0c0-.552-.225-1.053-.586-1.414a1.996 1.996 0 0 0-2.828 0 1.996 1.996 0 0 0 0 2.828 1.996 1.996 0 0 0 2.828 0c.361-.361.586-.862.586-1.414zM7 12c0-.552-.225-1.053-.586-1.414a1.996 1.996 0 0 0-2.828 0 1.996 1.996 0 0 0 0 2.828 1.996 1.996 0 0 0 2.828 0C6.775 13.053 7 12.552 7 12z" }) }), T3 = t(X5), K5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 5Zm1 3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8Zm2 2.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5Z",
        clipRule: "evenodd"
      }
    )
  }
), P3 = t(K5), Q5 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 10.857a1.143 1.143 0 1 1 0 2.286 1.143 1.143 0 0 1 0-2.286Zm0-4a1.143 1.143 0 1 1 0 2.286 1.143 1.143 0 0 1 0-2.286ZM9.143 4a1.143 1.143 0 1 0-2.286 0 1.143 1.143 0 0 0 2.286 0Z",
        clipRule: "evenodd"
      }
    )
  }
), k3 = t(Q5), e2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.307 12.101a.5.5 0 0 1-.807-.395V5.92a.5.5 0 0 1 .225-.418l3-1.973a.5.5 0 0 1 .55 0l3 1.973a.5.5 0 0 1 .225.418v5.786a.5.5 0 0 1-.807.395l-2.08-1.616a1 1 0 0 0-1.227 0l-2.08 1.616ZM3.5 11.706c0 1.248 1.435 1.95 2.42 1.185L8 11.275l2.08 1.616c.985.766 2.42.063 2.42-1.185V5.92a1.5 1.5 0 0 0-.676-1.254l-3-1.972a1.5 1.5 0 0 0-1.648 0l-3 1.972A1.5 1.5 0 0 0 3.5 5.92v5.786Z",
        clipRule: "evenodd"
      }
    )
  }
), O3 = t(e2), a2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "#5DB8C8",
        fillRule: "evenodd",
        d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-6.4 3.2 2.56V6.707a.579.579 0 0 0-.066-.274.76.76 0 0 0-.174-.22L8 3.84 5.04 6.213a.76.76 0 0 0-.174.22.578.578 0 0 0-.066.274v5.453L8 9.6Z",
        clipRule: "evenodd"
      }
    )
  }
), D3 = t(a2), o2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7ZM3 4.5A1.5 1.5 0 0 1 4.5 3h7A1.5 1.5 0 0 1 13 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5v-7Zm7.356 1.149a.5.5 0 0 1 .144.348V10a.5.5 0 0 1-1 0V7.207l-3.146 3.147a.5.5 0 0 1-.708-.708L8.793 6.5H6a.5.5 0 0 1 0-1h4c.137 0 .261.055.351.144l.005.005Z",
        clipRule: "evenodd"
      }
    )
  }
), W3 = t(o2), l2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.5 4A1.5 1.5 0 0 1 5 2.5h4.172c.025 0 .05 0 .076.002-.907 1.933 1.145 4.194 3.248 3.21.002.039.004.078.004.116V12a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 12V4Zm8.59.798-.03-.03-1.828-1.829a1.514 1.514 0 0 0-.056-.053c-.563 1.148.663 2.507 1.914 1.912ZM5 1.5A2.5 2.5 0 0 0 2.5 4v8A2.5 2.5 0 0 0 5 14.5h6a2.5 2.5 0 0 0 2.5-2.5V5.828a2.5 2.5 0 0 0-.732-1.767l-1.829-1.829A2.5 2.5 0 0 0 9.172 1.5H5Zm0 9a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM5.5 6a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM5 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
        clipRule: "evenodd"
      }
    )
  }
), N3 = t(l2), t2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.572 3.429a.571.571 0 0 0-.572.57v8c0 .316.256.572.572.572h4.49c.176 0 .348-.027.512-.078-.828-1.682.291-3.77 2.262-3.911l.124-.01a.585.585 0 0 1 .04 0V4a.571.571 0 0 0-.571-.571H4.572Zm7.14 6.544-1.199 1.798c-.284-.91.318-1.928 1.335-2.043a1.711 1.711 0 0 1-.136.245ZM2.857 4c0-.947.768-1.714 1.715-1.714h6.857c.947 0 1.714.767 1.714 1.714v5.022c0 .564-.167 1.116-.48 1.585l-1.223 1.835a2.857 2.857 0 0 1-2.377 1.272H4.572A1.714 1.714 0 0 1 2.857 12V4Zm2.858 1.143a.571.571 0 1 0 0 1.143h4.571a.571.571 0 1 0 0-1.143H5.715ZM5.143 8c0-.316.256-.572.572-.572h3.428a.571.571 0 0 1 0 1.143H5.715A.571.571 0 0 1 5.143 8Zm.572 1.714a.571.571 0 1 0 0 1.143H8a.571.571 0 0 0 0-1.143H5.715Z",
        clipRule: "evenodd"
      }
    )
  }
), U3 = t(t2), n2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m5.5 16 .625-2.5H3l.375-1.5H6.5l.875-3.5H4L4.375 7H7.75l.75-3H10l-.75 3h3L13 4h1.5l-.75 3H17l-.375 1.5h-3.25L12.5 12H16l-.375 1.5h-3.5L11.5 16H10l.625-2.5h-3L7 16H5.5ZM8 12h3l.875-3.5h-3L8 12Z"
      }
    )
  }
), Y3 = t(n2), r2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 5Zm1 3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8Zm2 2.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5Z",
        clipRule: "evenodd"
      }
    )
  }
), G3 = t(r2), s2 = (o, a) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 2.143a2.857 2.857 0 1 0 0 5.714 2.857 2.857 0 0 0 0-5.714ZM3.571 5A1.429 1.429 0 1 1 6.43 5 1.429 1.429 0 0 1 3.57 5ZM15 12.143a2.85 2.85 0 0 0-2.018.834l-.002.003-.003.002A2.85 2.85 0 0 0 12.143 15c0 .787.32 1.502.834 2.018l.003.002.002.003a2.85 2.85 0 0 0 2.018.834 2.85 2.85 0 0 0 2.018-.834l.002-.003.003-.002A2.85 2.85 0 0 0 17.857 15a2.85 2.85 0 0 0-.834-2.018l-.003-.002-.002-.003A2.85 2.85 0 0 0 15 12.143Zm-1.011 1.848v-.001l.002-.002c.26-.258.615-.417 1.009-.417.394 0 .75.159 1.009.418h.001l.002.002c.258.26.417.615.417 1.009 0 .394-.159.75-.417 1.009l-.002.001-.001.001c-.26.259-.615.418-1.009.418-.394 0-.75-.159-1.009-.418h-.001l-.001-.002A1.421 1.421 0 0 1 13.57 15c0-.394.159-.75.418-1.009Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.286 15a.714.714 0 1 1-1.429 0 .714.714 0 0 1 1.429 0ZM10.714 15.714a.714.714 0 1 0 0-1.428.714.714 0 0 0 0 1.428Z"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M6.429 5c0-.395.32-.714.714-.714h6.071a3.214 3.214 0 1 1 0 6.428H6.786a1.786 1.786 0 0 0-.357 3.536h.01a.725.725 0 1 1-.23 1.413 3.215 3.215 0 0 1 .577-6.377h6.428a1.786 1.786 0 0 0 0-3.572H7.143A.714.714 0 0 1 6.429 5Z"
        }
      )
    ]
  }
), q3 = t(s2), c2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.332 1.12a1.5 1.5 0 0 0-2.229.697.5.5 0 1 0 .931.365.5.5 0 0 1 .743-.23l4 2.667a.5.5 0 0 1 .223.416v5.596a.5.5 0 0 1-.746.436.5.5 0 1 0-.5.866c.987.569 2.246-.138 2.246-1.302V5.035a1.5 1.5 0 0 0-.668-1.248l-4-2.667ZM4.603 3.317c.33-.842 1.394-1.253 2.23-.697l4 2.667a1.5 1.5 0 0 1 .667 1.248v5.596c0 1.167-1.264 1.873-2.252 1.299a.5.5 0 0 1 .504-.865.5.5 0 0 0 .748-.434V6.535a.5.5 0 0 0-.223-.416l-4-2.667a.502.502 0 0 0-.743.23.5.5 0 0 1-.93-.365ZM2.777 4.952A.5.5 0 0 0 2 5.368v5.597a.5.5 0 0 0 .223.416l4 2.666A.5.5 0 0 0 7 13.631V8.035a.5.5 0 0 0-.223-.416l-4-2.667ZM1 5.368C1 4.17 2.335 3.456 3.332 4.12l4 2.667A1.5 1.5 0 0 1 8 8.035v5.596c0 1.198-1.335 1.913-2.332 1.248l-4-2.666A1.5 1.5 0 0 1 1 10.965V5.368Z",
        clipRule: "evenodd"
      }
    )
  }
), J3 = t(c2), h2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm1 2h2v14H7zm7-2a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm1 2h2v14h-2z" }) }), X3 = t(h2), i2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M23 12c0-3.037-1.232-5.789-3.222-7.778S15.037 1 12 1 6.211 2.232 4.222 4.222 1 8.963 1 12s1.232 5.789 3.222 7.778S8.963 23 12 23s5.789-1.232 7.778-3.222S23 15.037 23 12zm-2 0c0 2.486-1.006 4.734-2.636 6.364S14.486 21 12 21s-4.734-1.006-6.364-2.636S3 14.486 3 12s1.006-4.734 2.636-6.364S9.514 3 12 3s4.734 1.006 6.364 2.636S21 9.514 21 12zM8 13h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2h-3V8a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2z" }) }), K3 = t(i2), v2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M5 13h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2z" }) }), Q3 = t(v2), d2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.5 2a4.5 4.5 0 0 0-4.47 5.02A3.5 3.5 0 0 0 4.5 13h7a3.5 3.5 0 0 0 1.997-6.374L13.5 6.5a3 3 0 0 0-3.594-2.941A4.49 4.49 0 0 0 6.5 2ZM3 6.5a3.5 3.5 0 0 1 6.317-2.078l.214.29.344-.112a2 2 0 0 1 2.602 2.209l-.053.341.301.17A2.499 2.499 0 0 1 11.5 12h-7a2.5 2.5 0 0 1-1.614-4.41l.22-.185-.051-.284A3.524 3.524 0 0 1 3 6.5Zm7.356.851a.5.5 0 1 0-.712-.702L7.04 9.289l-1.183-1.2a.5.5 0 1 0-.712.702l1.54 1.56a.5.5 0 0 0 .711 0l2.96-3Z",
        clipRule: "evenodd"
      }
    )
  }
), e7 = t(d2), w2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 20 20", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "m12.973 10.201 2 2v1.5h-4.25v4.75l-.75.75-.75-.75v-4.75h-4.25v-1.5l2-2v-5.5h-1v-1.5h8v1.5h-1v5.5Zm-5.875 2h5.75l-1.375-1.375V4.701h-3v6.125l-1.375 1.375Z" }) }), a7 = t(w2), g2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M21.433 8.666c-.921-2.603-2.812-4.587-5.12-5.689s-5.04-1.323-7.643-.402a9.878 9.878 0 0 0-3.744 2.364L2 7.689V4a1 1 0 0 0-2 0v5.998l.001.044a1.003 1.003 0 0 0 .242.611l.036.039a.993.993 0 0 0 .71.307H7A1 1 0 0 0 7 9H3.524l2.83-2.659a7.87 7.87 0 0 1 2.983-1.88c2.083-.737 4.265-.561 6.114.322s3.359 2.468 4.096 4.551a1 1 0 1 0 1.885-.667zM20.475 15l-2.8 2.631c-1.584 1.585-3.63 2.366-5.679 2.366s-4.095-.78-5.657-2.342a7.86 7.86 0 0 1-1.883-2.981 1.001 1.001 0 0 0-1.892.65 9.862 9.862 0 0 0 2.361 3.745c1.953 1.952 4.514 2.928 7.072 2.927s5.118-.978 7.048-2.909L22 16.312V20a1 1 0 0 0 2 0v-5.998l-.001-.044a1.003 1.003 0 0 0-.242-.611l-.036-.039a.993.993 0 0 0-.71-.307H17a1 1 0 0 0 0 2z" }) }), o7 = t(g2), m2 = (o, a) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14.52 6.504A5.714 5.714 0 0 0 4.33 9.288a.853.853 0 0 1-.03.14c-.097.325-.383.572-.729.572-.394 0-.718-.32-.678-.713a7.144 7.144 0 0 1 12.906-3.458c.23.32.11.76-.232.957-.3.173-.67.101-.917-.131a.84.84 0 0 1-.095-.105m-.035-.046.034.044-.034-.044ZM5.48 13.496a5.714 5.714 0 0 0 10.19-2.784.881.881 0 0 1 .03-.14c.098-.325.383-.572.729-.572.394 0 .718.32.678.713a7.144 7.144 0 0 1-12.906 3.458c-.23-.32-.11-.76.232-.957.3-.173.67-.101.917.131a.865.865 0 0 1 .095.106m.035.045a4.576 4.576 0 0 1-.034-.044l.034.044Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.581 6.463h-3.326a.714.714 0 1 0 0 1.429h3.598c.639 0 1.157-.518 1.157-1.157V3.137a.714.714 0 0 0-1.429 0v3.326ZM4.42 13.54h3.326a.714.714 0 0 0 0-1.429H4.148c-.64 0-1.157.518-1.157 1.157v3.598a.714.714 0 1 0 1.429 0V13.54Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), l7 = t(m2), f2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "#000",
        fillRule: "evenodd",
        d: "M4.571 2.286c0-.316.256-.572.572-.572h2.286a.571.571 0 1 1 0 1.143h-.572v10.286h.572a.571.571 0 0 1 0 1.143H5.143a.571.571 0 0 1 0-1.143h.571V2.857h-.571a.571.571 0 0 1-.572-.571ZM1.714 5.714C1.714 4.768 2.482 4 3.43 4H4a.571.571 0 1 1 0 1.143h-.571a.571.571 0 0 0-.572.571v4.572c0 .315.256.571.572.571H4A.571.571 0 1 1 4 12h-.571a1.714 1.714 0 0 1-1.715-1.714V5.714ZM8.571 4a.571.571 0 0 0 0 1.143h4c.316 0 .572.256.572.571v4.572a.571.571 0 0 1-.572.571h-4a.571.571 0 1 0 0 1.143h4c.947 0 1.715-.767 1.715-1.714V5.714c0-.946-.768-1.714-1.714-1.714h-4Z",
        clipRule: "evenodd"
      }
    )
  }
), t7 = t(f2), u2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M4 11V9c0-.829.335-1.577.879-2.121S6.171 6 7 6h11.586l-2.293 2.293a.999.999 0 1 0 1.414 1.414l4-4a.998.998 0 0 0 0-1.414l-4-4a.999.999 0 1 0-1.414 1.414L18.586 4H7c-1.38 0-2.632.561-3.536 1.464S2 7.62 2 9v2a1 1 0 0 0 2 0zm16 2v2c0 .829-.335 1.577-.879 2.121S17.829 18 17 18H5.414l2.293-2.293a.999.999 0 1 0-1.414-1.414l-4 4a.998.998 0 0 0 0 1.414l4 4a.999.999 0 1 0 1.414-1.414L5.414 20H17c1.38 0 2.632-.561 3.536-1.464S22 16.38 22 15v-2a1 1 0 0 0-2 0z" }) }), n7 = t(u2), x2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M17 22v-3h-3v-2h3v-3h2v3h3v2h-3v3h-2ZM5 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V2h2v2h6V2h2v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v6.1a6.732 6.732 0 0 0-2 0V10H5v8h7c0 .333.025.667.075 1 .05.333.142.667.275 1H5ZM5 8h12V6H5v2Z"
      }
    )
  }
), r7 = t(x2), p2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V2h2v2h8V2h2v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 22H5Zm0-2h14V10H5v10ZM5 8h14V6H5v2Z"
      }
    )
  }
), s7 = t(p2), R2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M14.5 18c-.7 0-1.292-.242-1.775-.725C12.242 16.792 12 16.2 12 15.5s.242-1.292.725-1.775C13.208 13.242 13.8 13 14.5 13s1.292.242 1.775.725c.483.483.725 1.075.725 1.775s-.242 1.292-.725 1.775c-.483.483-1.075.725-1.775.725ZM5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V2h2v2h8V2h2v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 22H5Zm0-2h14V10H5v10ZM5 8h14V6H5v2Z"
      }
    )
  }
), c7 = t(R2), Z2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V2h2v2h8V2h2v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 22H5Zm0-2h14V10H5v10ZM5 8h14V6H5v2Zm7 6a.968.968 0 0 1-.713-.287A.968.968 0 0 1 11 13c0-.283.096-.52.287-.713A.968.968 0 0 1 12 12c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.968.968 0 0 1 12 14Zm-4 0a.967.967 0 0 1-.713-.287A.968.968 0 0 1 7 13c0-.283.096-.52.287-.713A.967.967 0 0 1 8 12c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.967.967 0 0 1 8 14Zm8 0a.968.968 0 0 1-.713-.287A.968.968 0 0 1 15 13c0-.283.096-.52.287-.713A.968.968 0 0 1 16 12c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 16 14Zm-4 4a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 17c0-.283.096-.52.287-.712A.968.968 0 0 1 12 16c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0 1 12 18Zm-4 0a.967.967 0 0 1-.713-.288A.968.968 0 0 1 7 17c0-.283.096-.52.287-.712A.967.967 0 0 1 8 16c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.967.967 0 0 1 8 18Zm8 0a.968.968 0 0 1-.713-.288A.968.968 0 0 1 15 17c0-.283.096-.52.287-.712A.968.968 0 0 1 16 16c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0 1 16 18Z"
      }
    )
  }
), h7 = t(Z2), j2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "m9.7 18.7-1.4-1.4 2.3-2.3-2.3-2.3 1.4-1.4 2.3 2.3 2.3-2.3 1.4 1.4-2.3 2.3 2.3 2.3-1.4 1.4-2.3-2.3-2.3 2.3ZM5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V2h2v2h8V2h2v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 22H5Zm0-2h14V10H5v10ZM5 8h14V6H5v2Z"
      }
    )
  }
), i7 = t(j2), A2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M16.55 22.5 13 18.95l1.4-1.4 2.125 2.125 4.25-4.25 1.4 1.425-5.625 5.65ZM7.4 17 6 15.6 7.6 14 6 12.4 7.4 11 9 12.6l1.6-1.6 1.4 1.4-1.6 1.6 1.6 1.6-1.4 1.4L9 15.4 7.4 17ZM5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V2h2v2h8V2h2v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v6.35l-2 2.025V10H5v10h6.25l1.975 2H5ZM5 8h14V6H5v2Z"
      }
    )
  }
), v7 = t(A2), M2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 14a.967.967 0 0 1-.713-.287A.968.968 0 0 1 7 13c0-.283.096-.52.287-.713A.967.967 0 0 1 8 12c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.967.967 0 0 1 8 14Zm4 0a.968.968 0 0 1-.713-.287A.968.968 0 0 1 11 13c0-.283.096-.52.287-.713A.968.968 0 0 1 12 12c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.968.968 0 0 1 12 14Zm4 0a.968.968 0 0 1-.713-.287A.968.968 0 0 1 15 13c0-.283.096-.52.287-.713A.968.968 0 0 1 16 12c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 16 14ZM5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V2h2v2h8V2h2v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 22H5Zm0-2h14V10H5v10ZM5 8h14V6H5v2Z"
      }
    )
  }
), d7 = t(M2), V2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V2h2v2h8V2h2v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v6h-2v-2H5v10h7v2H5Zm14 2c-1.217 0-2.28-.38-3.188-1.137A4.9 4.9 0 0 1 14.1 20h1.55c.217.733.63 1.333 1.237 1.8.609.467 1.313.7 2.113.7.967 0 1.792-.342 2.475-1.025A3.372 3.372 0 0 0 22.5 19c0-.967-.342-1.792-1.025-2.475A3.372 3.372 0 0 0 19 15.5a3.404 3.404 0 0 0-2.45 1H18V18h-4v-4h1.5v1.425c.45-.433.975-.78 1.575-1.038A4.816 4.816 0 0 1 19 14c1.383 0 2.563.488 3.538 1.463C23.512 16.438 24 17.617 24 19s-.488 2.563-1.462 3.538C21.562 23.512 20.383 24 19 24ZM5 8h14V6H5v2Z"
      }
    )
  }
), w7 = t(V2), H2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.426 2.646a.5.5 0 0 0-.852 0L3.62 7.45c-1.628 2.645.275 6.051 3.38 6.051.852 0 1.612-.255 2.234-.68a4.499 4.499 0 0 0 1.33.18c-.88.91-2.117 1.5-3.563 1.5-3.888 0-6.271-4.264-4.233-7.575l2.955-4.803a1.5 1.5 0 0 1 2.555 0l1.225 1.99a4.467 4.467 0 0 0-.966.338l-1.11-1.804ZM4.5 9.5a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 1.5 1.5.5.5 0 1 1 0 1A2.5 2.5 0 0 1 4 10a.5.5 0 0 1 .5-.5Zm6-3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM7 8.5a3.5 3.5 0 1 1 6.3 2.1c.019.014.037.03.054.047l1 1a.5.5 0 0 1-.708.707l-1-1a.504.504 0 0 1-.046-.054A3.5 3.5 0 0 1 7 8.5Z",
        clipRule: "evenodd"
      }
    )
  }
), g7 = t(H2), S2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V2h2v2h8V2h2v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 22H5Zm0-2h14V10H5v10ZM5 8h14V6H5v2Zm2 6v-2h10v2H7Zm0 4v-2h7v2H7Z"
      }
    )
  }
), m7 = t(S2), C2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.143 2.857a.714.714 0 1 0-1.429 0v.357H4.286c-1.184 0-2.143.96-2.143 2.143v10.357c0 1.184.96 2.143 2.143 2.143h11.428c1.184 0 2.143-.96 2.143-2.143V5.357c0-1.183-.96-2.143-2.143-2.143h-1.428v-.357a.714.714 0 1 0-1.429 0v.357H7.143v-.357ZM12.857 5v-.357H7.143V5a.714.714 0 0 1-1.429 0v-.357H4.286a.714.714 0 0 0-.715.714v1.786H16.43V5.357a.714.714 0 0 0-.715-.714h-1.428V5a.714.714 0 1 1-1.429 0Zm3.572 3.571H3.57v7.143c0 .395.32.714.715.714h11.428c.395 0 .715-.32.715-.714V8.571Zm-9.286 2.5a.714.714 0 1 1-1.429 0 .714.714 0 0 1 1.429 0Zm-.714 3.572a.714.714 0 1 0 0-1.429.714.714 0 0 0 0 1.429Zm4.285-3.572a.714.714 0 1 1-1.428 0 .714.714 0 0 1 1.428 0ZM10 14.643a.714.714 0 1 0 0-1.429.714.714 0 0 0 0 1.429Zm4.286-3.572a.714.714 0 1 1-1.429 0 .714.714 0 0 1 1.429 0Zm-.714 3.572a.714.714 0 1 0 0-1.429.714.714 0 0 0 0 1.429Z",
        clipRule: "evenodd"
      }
    )
  }
), f7 = t(C2), F2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M16.041 15.856a.995.995 0 0 0-.186.186A6.97 6.97 0 0 1 11 18c-1.933 0-3.682-.782-4.95-2.05S4 12.933 4 11s.782-3.682 2.05-4.95S9.067 4 11 4s3.682.782 4.95 2.05S18 9.067 18 11a6.971 6.971 0 0 1-1.959 4.856zm5.666 4.437-3.675-3.675A8.967 8.967 0 0 0 20 11c0-2.485-1.008-4.736-2.636-6.364S13.485 2 11 2 6.264 3.008 4.636 4.636 2 8.515 2 11s1.008 4.736 2.636 6.364S8.515 20 11 20a8.967 8.967 0 0 0 5.618-1.968l3.675 3.675a.999.999 0 1 0 1.414-1.414z" }) }), u7 = t(F2), I2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.572 6.753c0-.394.32-.714.714-.714h11.428a.714.714 0 1 1 0 1.429H4.286a.714.714 0 0 1-.714-.715Zm0 3.572c0-.395.32-.715.714-.715h11.428a.714.714 0 0 1 0 1.429H4.286a.714.714 0 0 1-.714-.714Zm.714 2.857a.714.714 0 0 0 0 1.428H10a.714.714 0 1 0 0-1.428H4.286Z",
        clipRule: "evenodd"
      }
    )
  }
), x7 = t(I2), B2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 2c.286 0 .544.17.656.433l1.972 4.6 4.566.326a.714.714 0 0 1 .454 1.218l-3.301 3.3.996 4.983a.714.714 0 0 1-1.075.748L10 14.982l-4.269 2.626a.714.714 0 0 1-1.064-.792l1.317-4.937L2.377 8.6a.714.714 0 0 1 .43-1.241l4.565-.326 1.971-4.6A.714.714 0 0 1 10 2Zm0 2.528L8.514 7.996a.714.714 0 0 1-.606.43l-3.336.24 2.694 2.448c.198.18.279.455.21.713l-.967 3.625 3.117-1.918a.715.715 0 0 1 .748 0l3.247 1.998-.75-3.75a.715.715 0 0 1 .195-.644l2.466-2.466-3.44-.245a.714.714 0 0 1-.606-.431L10 4.528Z",
        clipRule: "evenodd"
      }
    )
  }
), p7 = t(B2), $2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.656 2.719a.714.714 0 0 0-1.313 0l-1.97 4.6-4.567.326a.714.714 0 0 0-.43 1.24l3.608 3.28-1.317 4.937a.714.714 0 0 0 1.064.792L10 15.267l4.268 2.627a.714.714 0 0 0 1.075-.748l-.996-4.983 3.3-3.3a.714.714 0 0 0-.453-1.218l-4.566-.327-1.972-4.6Z",
        clipRule: "evenodd"
      }
    )
  }
), R7 = t($2), L2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.408 2.751c.108.26.164.539.164.82h2.142c1.184 0 2.143.96 2.143 2.143v10c0 1.184-.96 2.143-2.143 2.143H12.02a2.143 2.143 0 0 0 0-1.428h3.694c.395 0 .715-.32.715-.715v-10A.714.714 0 0 0 15.714 5H7.143a.714.714 0 0 0-.714.714H5c0-1.183.96-2.143 2.143-2.143h2.143a2.143 2.143 0 0 1 4.122-.82Zm.878 11.535H11.12l-.604-1.429h3.77a.714.714 0 1 1 0 1.429Zm0-2.857H9.913l-.056-.134V10h4.429a.714.714 0 1 1 0 1.429ZM12.143 8.57h-.836a2.141 2.141 0 0 0 0-1.428h.836a.714.714 0 1 1 0 1.428Zm-.714-4.642a.714.714 0 1 0 0-1.429.714.714 0 0 0 0 1.429ZM2.857 7.857c0-.394.32-.714.714-.714h5.715a.714.714 0 0 1 0 1.428h-.858v3.014l2.23 5.28a.714.714 0 0 1-.658.992H2.857a.714.714 0 0 1-.658-.992l2.23-5.28V8.57h-.858a.714.714 0 0 1-.714-.714Zm3 .714H7v3.158c0 .096.02.19.057.278l1.867 4.422H3.934l1.867-4.422a.714.714 0 0 0 .057-.278V8.571Z",
        clipRule: "evenodd"
      }
    )
  }
), Z7 = t(L2), b2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3.5a.5.5 0 0 0-1 0v4A2.5 2.5 0 0 0 4.5 10h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L13.293 9H4.5A1.5 1.5 0 0 1 3 7.5v-4Z",
        clipRule: "evenodd"
      }
    )
  }
), j7 = t(b2), E2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.5 17c-.412 0-.766-.15-1.06-.448A1.452 1.452 0 0 1 3 15.5V13h1.5v2.5h11V6h-11v3H3V4.5c0-.403.147-.753.44-1.052A1.433 1.433 0 0 1 4.5 3h11c.412 0 .766.15 1.06.448.293.299.44.65.44 1.052v11c0 .403-.147.753-.44 1.052A1.433 1.433 0 0 1 15.5 17h-11Zm5-2.5-1.063-1.063 1.688-1.687H3v-1.5h7.125L8.437 8.562 9.5 7.5 13 11l-3.5 3.5Z"
      }
    )
  }
), A7 = t(E2), y2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4.286A.714.714 0 0 0 4.286 5v2.143h2.857V4.286H5Zm3.571 0v2.857h2.857V4.286H8.572ZM7.143 8.57H4.286v2.858h2.857V8.57Zm0 4.286H4.286V15c0 .395.32.714.714.714h2.143v-2.857Zm1.428 2.857V8.571h7.143V15c0 .395-.32.714-.714.714H8.571Zm-.713 1.429H15c1.183 0 2.143-.96 2.143-2.143V5c0-1.183-.96-2.143-2.143-2.143H5c-1.183 0-2.143.96-2.143 2.143v10c0 1.183.96 2.143 2.143 2.143H7.858Zm7.856-10h-2.857V4.286H15c.395 0 .714.32.714.714v2.143Z",
        clipRule: "evenodd"
      }
    )
  }
), M7 = t(y2), z2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 2.665a.5.5 0 0 0-.735-.442l-5 2.66A.5.5 0 0 0 3 5.325V13.5a.5.5 0 0 0 .5.5h1v-2.5a1.5 1.5 0 0 1 3 0V14H9V2.665ZM6.5 14v-2.5a.5.5 0 1 0-1 0V14h1ZM5 15H3.5A1.5 1.5 0 0 1 2 13.5V5.325A1.5 1.5 0 0 1 2.795 4l5-2.66A1.5 1.5 0 0 1 10 2.664V4.5h2.5A1.5 1.5 0 0 1 14 6v7.5a1.5 1.5 0 0 1-1.5 1.5H5Zm5-1V5.5h2.5a.5.5 0 0 1 .5.5v7.5a.5.5 0 0 1-.5.5H10ZM4 6.5a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 0 1h-.5a.5.5 0 0 1-.5-.5ZM7 6a.5.5 0 0 0 0 1h.5a.5.5 0 0 0 0-1H7Zm-.5-1.5A.5.5 0 0 1 7 4h.5a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5ZM7 8a.5.5 0 0 0 0 1h.5a.5.5 0 0 0 0-1H7Zm3.75 3.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 1 1 0 1h-.5a.5.5 0 0 1-.5-.5Zm.5-2.5a.5.5 0 0 0 0 1h.5a.5.5 0 0 0 0-1h-.5Zm-.5-1.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 0 1h-.5a.5.5 0 0 1-.5-.5ZM4.5 8a.5.5 0 0 0 0 1H5a.5.5 0 0 0 0-1h-.5Z",
        clipRule: "evenodd"
      }
    )
  }
), V7 = t(z2), _2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", ref: a, ...o, children: /* @__PURE__ */ e.jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M5.714 7.429a2.857 2.857 0 1 1 4.572 0h1.33c.246-.52.384-1.101.384-1.715 0-.613-.138-1.194-.385-1.714h.51l.857 3.429H3.018L3.875 4h.51C4.138 4.52 4 5.1 4 5.714c0 .614.138 1.195.385 1.715h1.33Zm-.513-4.572H3.429a.571.571 0 0 0-.555.433L1.731 7.862A.572.572 0 0 0 1.714 8v4.572c0 .946.768 1.714 1.715 1.714h9.143c.946 0 1.714-.768 1.714-1.714V8a.568.568 0 0 0-.017-.138L13.126 3.29a.571.571 0 0 0-.554-.433H10.8A3.987 3.987 0 0 0 8 1.714c-1.09 0-2.078.436-2.8 1.143ZM8 3.43c.315 0 .57.256.57.571v1.361l.828.414a.571.571 0 0 1-.512 1.022l-1.142-.572a.571.571 0 0 1-.316-.51V4c0-.315.256-.571.571-.571Zm5.142 5.143v4a.571.571 0 0 1-.572.571H3.43a.571.571 0 0 1-.572-.571v-4h10.286Zm-6.286 2.285a.571.571 0 1 0-1.143 0v.572c0 .315.256.571.572.571h3.428a.571.571 0 0 0 .572-.571v-.572a.571.571 0 0 0-1.143 0H6.857Z",
    clipRule: "evenodd"
  }
) }), H7 = t(_2), T2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M18 7v13c0 .276-.111.525-.293.707S17.276 21 17 21H7c-.276 0-.525-.111-.707-.293S6 20.276 6 20V7zm-1-2V4a2.997 2.997 0 0 0-3-3h-4a2.997 2.997 0 0 0-3 3v1H3a1 1 0 0 0 0 2h1v13a2.997 2.997 0 0 0 3 3h10a2.997 2.997 0 0 0 3-3V7h1a1 1 0 0 0 0-2zM9 5V4c0-.276.111-.525.293-.707S9.724 3 10 3h4c.276 0 .525.111.707.293S15 3.724 15 4v1zm0 6v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-2 0zm4 0v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-2 0z" }) }), S7 = t(T2), P2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "m0 16 16 16V0z" }) }), C7 = t(P2), k2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M16 16 0 0v32z" }) }), F7 = t(k2), O2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 32 32", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M21 13.6H11v-3.2h10a7.6 7.6 0 0 1 0 15.2h-4a1.6 1.6 0 1 1 0-3.2h4a4.4 4.4 0 0 0 0-8.8zM11 17.103V6.897c0-1.069-1.293-1.604-2.049-.849l-5.103 5.103a1.2 1.2 0 0 0 0 1.697l5.103 5.103c.756.756 2.049.221 2.049-.849z" }) }), I7 = t(O2), D2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "m12.667 10.117-.934-.917a2.128 2.128 0 0 0 1.132-.728c.29-.359.435-.766.435-1.222 0-.556-.195-1.028-.583-1.417A1.929 1.929 0 0 0 11.3 5.25H8.9v-1.2h2.4c.885 0 1.64.312 2.264.937a3.09 3.09 0 0 1 .936 2.267 3.05 3.05 0 0 1-.492 1.68 3.265 3.265 0 0 1-1.341 1.183ZM10.4 7.85l-1.2-1.2h1.3v1.2h-.1Zm2.5 5.9L1.6 2.45l.85-.85 11.3 11.3-.85.85Zm-5.6-3.3H4.9c-.885 0-1.64-.312-2.264-.936A3.084 3.084 0 0 1 1.7 7.25c0-.71.211-1.344.633-1.9.423-.555 1.023-.994 1.8-1.317L5.3 5.25h-.383c-.567 0-1.045.194-1.434.583A1.929 1.929 0 0 0 2.9 7.25c0 .556.194 1.028.583 1.417.39.389.861.583 1.417.583h2.4v1.2Zm-1.6-2.6v-1.2h.933l1.184 1.2H5.7Z" }) }), B7 = t(D2), W2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 1.714c.316 0 .571.256.571.572v5.477l1.31-1.31a.571.571 0 1 1 .809.808L8.408 9.543a.575.575 0 0 1-.671.107.569.569 0 0 1-.145-.107L5.31 7.261a.571.571 0 0 1 .808-.808l1.31 1.31V2.286c0-.316.256-.572.572-.572ZM12.57 4c.316 0 .572.256.572.572v6.857a.571.571 0 0 1-.572.571H3.43a.571.571 0 0 1-.572-.571V4.572c0-.316.256-.572.572-.572h1.714a.571.571 0 1 0 0-1.143H3.429c-.947 0-1.715.768-1.715 1.715v6.857c0 .946.768 1.714 1.715 1.714h9.142c.947 0 1.715-.768 1.715-1.714V4.572c0-.947-.768-1.715-1.715-1.715h-1.714a.571.571 0 1 0 0 1.143h1.714Z",
        clipRule: "evenodd"
      }
    )
  }
), $7 = t(W2), N2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M20 15v4c0 .276-.111.525-.293.707S19.276 20 19 20H5c-.276 0-.525-.111-.707-.293S4 19.276 4 19v-4a1 1 0 0 0-2 0v4a2.997 2.997 0 0 0 3 3h14a2.997 2.997 0 0 0 3-3v-4a1 1 0 0 0-2 0zm-9-9.586V15a1 1 0 0 0 2 0V5.414l3.293 3.293a.999.999 0 1 0 1.414-1.414l-5-5a.998.998 0 0 0-1.414 0l-5 5a.999.999 0 1 0 1.414 1.414z" }) }), L7 = t(N2), U2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.572 4.286a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-3.929 2.5a3.929 3.929 0 1 1 7.857 0 3.929 3.929 0 0 1-7.857 0ZM2.857 15a3.571 3.571 0 0 1 3.572-3.571h4.286A3.571 3.571 0 0 1 14.286 15v.714c0 .79-.64 1.429-1.429 1.429H4.286c-.789 0-1.429-.64-1.429-1.429V15Zm3.572-2.143c-1.184 0-2.143.96-2.143 2.143v.714h8.571V15c0-1.183-.959-2.143-2.142-2.143H6.429Zm6.786-6.071a4.64 4.64 0 0 1-2.143 3.912 3.928 3.928 0 1 0 0-7.825 4.64 4.64 0 0 1 2.143 3.913ZM15 15.714c0 .55-.206 1.05-.545 1.429h1.26c.789 0 1.428-.64 1.428-1.429V15a3.571 3.571 0 0 0-3.571-3.571h-.488A4.282 4.282 0 0 1 15 15v.714Z",
        clipRule: "evenodd"
      }
    )
  }
), b7 = t(U2), Y2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.638 4.077a.714.714 0 1 1 1.01-1.01L10 5.417l2.352-2.352a.714.714 0 1 1 1.01 1.01l-2.857 2.858a.714.714 0 0 1-1.01 0L6.638 4.077Zm0 11.846a.714.714 0 0 0 1.01 1.01L10 14.581l2.352 2.352a.714.714 0 0 0 1.01-1.01l-2.857-2.857a.714.714 0 0 0-1.01 0l-2.857 2.857Z",
        clipRule: "evenodd"
      }
    )
  }
), E7 = t(Y2), G2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.638 5.923a.714.714 0 1 0 1.01 1.01L10 4.581l2.352 2.352a.714.714 0 1 0 1.01-1.01l-2.857-2.857a.714.714 0 0 0-1.01 0L6.638 5.923Zm0 8.153a.714.714 0 1 1 1.01-1.01L10 15.418l2.352-2.352a.714.714 0 1 1 1.01 1.01l-2.857 2.858a.714.714 0 0 1-1.01 0l-2.857-2.858Z",
        clipRule: "evenodd"
      }
    )
  }
), y7 = t(G2), q2 = (o, a) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: a,
    ...o,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.929 13.943h8.142c1.685 0 2.734-1.829 1.883-3.283l-4.07-6.961c-.843-1.44-2.925-1.44-3.768 0l-4.07 6.96c-.851 1.455.198 3.284 1.883 3.284Zm4.649-2.857a.571.571 0 0 1-.572.571H8a.571.571 0 1 1 0-1.143h.006c.316 0 .572.256.572.572ZM8 9.943a.571.571 0 0 1-.572-.571V5.943a.571.571 0 0 1 1.143 0v3.429A.571.571 0 0 1 8 9.943Z",
        clipRule: "evenodd"
      }
    )
  }
), z7 = t(q2), J2 = (o, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: a, ...o, children: /* @__PURE__ */ e.jsx("path", { d: "M5.293 6.707 10.586 12l-5.293 5.293a.999.999 0 1 0 1.414 1.414L12 13.414l5.293 5.293a.999.999 0 1 0 1.414-1.414L13.414 12l5.293-5.293a.999.999 0 1 0-1.414-1.414L12 10.586 6.707 5.293a.999.999 0 1 0-1.414 1.414z" }) }), _7 = t(J2);
export {
  K2 as AddDocumentDocument2Icon,
  Q2 as AddFootnoteIcon,
  e4 as AddIcon,
  a4 as AdjustCountIcon,
  o4 as AppsIcon,
  l4 as ArrowDownIcon,
  t4 as ArrowEastIcon,
  n4 as ArrowLeftIcon,
  r4 as ArrowNorthEastIcon,
  c4 as ArrowNorthIcon,
  s4 as ArrowNorthWestIcon,
  h4 as ArrowRightIcon,
  i4 as ArrowSouthEastIcon,
  d4 as ArrowSouthIcon,
  v4 as ArrowSouthWestIcon,
  w4 as ArrowUpIcon,
  g4 as ArrowWestIcon,
  m4 as AssessmentsAndMeasurementsIcon,
  f4 as BookIcon,
  u4 as BulletIcon,
  x4 as CalendarIcon,
  p4 as CancelIcon,
  R4 as CarIcon,
  Z4 as CaratDownIcon,
  j4 as CaratRightIcon,
  M4 as ChartIcon,
  A4 as ChartLineBarIcon,
  V4 as CheckIcon,
  H4 as CheckboxCheckedHollowIcon,
  S4 as CheckboxCheckedIcon,
  C4 as CheckboxDisabledIcon,
  F4 as CheckboxIndeterminateIcon,
  I4 as CheckboxUncheckedIcon,
  B4 as ChevronDownIcon,
  $4 as ChevronLeftIcon,
  L4 as ChevronRightIcon,
  b4 as ChevronUpIcon,
  E4 as Clock2Icon,
  y4 as ClockIcon,
  z4 as Collapse2Icon,
  _4 as CollapseAllIcon,
  P4 as CollapseIcon,
  T4 as CollapseLessIcon,
  k4 as CommentAltIcon,
  O4 as CommentIcon,
  D4 as CompareIcon,
  W4 as ContentCopyIcon,
  N4 as CorporateFareIcon,
  U4 as DatabaseIcon,
  Y4 as Deprecated2Icon,
  G4 as DeprecatedIcon,
  q4 as DocumentNewIcon,
  J4 as DoneIcon,
  X4 as DotIcon,
  K4 as DownloadIcon,
  Q4 as EditCircleIcon,
  e3 as EditIcon,
  a3 as ErrorIcon,
  o3 as ExpandAllIcon,
  l3 as ExpandMoreIcon,
  t3 as EyeIcon,
  n3 as FaroTextIcon,
  r3 as FastingIcon,
  s3 as FileTextIcon,
  c3 as FilterIcon,
  h3 as FormIcon,
  i3 as GlobalIcon,
  v3 as GlobeIcon,
  d3 as GridViewIcon,
  w3 as GroupByIcon,
  g3 as HandleIcon,
  m3 as HasPanelMembers2Icon,
  f3 as HasPanelMembersIcon,
  u3 as HistoryIcon,
  x3 as HomeIcon,
  p3 as IcCheckCircle24PxIcon,
  R3 as IcEdit24PxIcon,
  Z3 as IcInfo48PxIcon,
  j3 as ImportIcon,
  A3 as InfoIcon,
  M3 as InsertBelowIcon,
  V3 as InsertBetweenIcon,
  H3 as LabelIcon,
  S3 as LaunchIcon,
  C3 as LayersIcon,
  F3 as LeadingIcon,
  I3 as LibraryIcon,
  B3 as LinkIcon,
  $3 as ListIcon,
  L3 as LogoIcon,
  b3 as LogoutIcon,
  E3 as Maximize2Icon,
  y3 as MaximizeIcon,
  z3 as MinusCircleIcon,
  _3 as MinusIcon,
  T3 as MoreHorizontalIcon,
  P3 as MoreOptionsIcon,
  k3 as MoreVerticalIcon,
  O3 as MostCommon2Icon,
  D3 as MostCommonIcon,
  W3 as NewTabIcon,
  N3 as NoteIcon,
  U3 as NotesIcon,
  Y3 as NumberIcon,
  G3 as OpenFilterIcon,
  q3 as OriginIcon,
  J3 as OverlayIcon,
  X3 as PauseIcon,
  K3 as PlusCircleIcon,
  Q3 as PlusIcon,
  e7 as PublishedIcon,
  a7 as PushPinIcon,
  o7 as RefreshCcwIcon,
  l7 as RefreshIcon,
  t7 as RenameIcon,
  n7 as RepeatIcon,
  r7 as RuleCreateIcon,
  s7 as RuleCustomIcon,
  c7 as RuleDayWithinRangeIcon,
  h7 as RuleEveryVisitWithinRangeIcon,
  i7 as RuleExceptionIcon,
  v7 as RuleGenericIcon,
  d7 as RuleIndividualIcon,
  w7 as RuleRecurringIcon,
  g7 as SampleTypeIcon,
  f7 as ScheduleIcon,
  m7 as ScheduleNoteIcon,
  u7 as SearchIcon,
  x7 as SectionIcon,
  R7 as StarIcon,
  p7 as StarOutlineIcon,
  Z7 as StudyDefinitionIcon,
  j7 as SubIcon,
  A7 as TabMoveIcon,
  M7 as TableIcon,
  V7 as TenantIcon,
  H7 as TimeBoxIcon,
  S7 as Trash2Icon,
  C7 as TriangleLeftIcon,
  F7 as TriangleRightIcon,
  I7 as UndoIcon,
  B7 as UnlinkIcon,
  $7 as UpdateIcon,
  L7 as UploadIcon,
  b7 as UsersIcon,
  E7 as VerticalArrowsInIcon,
  y7 as VerticalArrowsOutIcon,
  z7 as WarningIcon,
  _7 as XIcon
};
//# sourceMappingURL=faro-icons.es.js.map
